/*
 * 简体中文
 * */
// 第三方游戏相关翻译
import thirdGamesCN from '/@/kernel-mn/languages/thirdGames/cn';
import lotteryCN from '/@/kernel-mn/languages/lottery/cn';

// kernel 里只放kernel公共项目里的翻译
const kernel = {
  'admin': '管理员',
  'owner': '群主',
  '充值中心': '充值中心',
  '投注成功, 祝您中奖': '投注成功, 祝您中奖',
  '余额不足': '余额不足',
  '无法获得期号信息': '无法获得期号信息',
  '当前期已封期': '当前期已封期',
  '{key}期，不在销售中': '{key}期，不在销售中',
  '确定要新增{key}吗?': '确定要新增{key}吗?',
  '新增{key}成功': '新增{key}成功',
  '确定要新增{key}推广链接吗?': '确定要新增{key}推广链接吗?',
  '同一个银行卡绑定人数过多': '同一个银行卡绑定人数过多',
  '同一个姓名绑定人数过多': '同一个姓名绑定人数过多',
  '同一个电话注册人数过多!': '同一个电话注册人数过多!',
  '同一个姓名注册人数过多!': '同一个姓名注册人数过多!',
  '同一个设备注册人数过多!': '同一个设备注册人数过多!',
  '同一个ip注册人数过多!': '同一个ip注册人数过多!',
  '充值拒绝原因': '充值拒绝原因',
  '温馨提醒: 若使用该通道进行充值，到账成功后将扣除{n}手续费，若同意请确定': '温馨提醒: 若使用该通道进行充值，到账成功后将扣除{n}手续费，若同意请确定',
  '客户{a}，线上充值成功': '客户{a}，线上充值成功',
  '客户{a}，充值{b}，成功到账': '客户{a}，充值{b}，成功到账',
  '客户{a}，充值{b}，充值失败，如有疑问请联系客服处理': '客户{a}，充值{b}，充值失败，如有疑问请联系客服处理',
  '客户{a}，提现{b}，成功到账{c}': '客户{a}，提现{b}，成功到账{c}',
  '客户{a}，提现{b}，提现失败，如有疑问请联系客服处理': '客户{a}，提现{b}，提现失败，如有疑问请联系客服处理',
  '客户{a}，已获得注册账号奖励，奖励金额{b}，已发放至账户': '客户{a}，已获得注册账号奖励，奖励金额{b}，已发放至账户',
  '客户{a}，已获得填写真实姓名奖励，奖励金额{b}，已发放至账户': '客户{a}，已获得填写真实姓名奖励，奖励金额{b}，已发放至账户',
  '客户{a}，已获得填写手机号奖励，奖励金额{b}，已发放至账户': '客户{a}，已获得填写手机号奖励，奖励金额{b}，已发放至账户',
  '客户{a}，已获得绑定银行卡奖励，奖励金额{b}，已发放至账户': '客户{a}，已获得绑定银行卡奖励，奖励金额{b}，已发放至账户',
  '客户{a}，已获得二次奖励，奖励金额{b}，已发放至账户': '客户{a}，已获得二次奖励，奖励金额{b}，已发放至账户',
  '客户{a}，已获得三次奖励，奖励金额{b}，已发放至账户': '客户{a}，已获得三次奖励，奖励金额{b}，已发放至账户',
  '客户{a}，已获得注册账号奖励，奖励金额{b}积分，已发放至账户': '客户{a}，已获得注册账号奖励，奖励金额{b}积分，已发放至账户',
  '当前{k}账号已被绑定': '当前{k}账号已被绑定',
  '累计充值,打码量,亏损不足，不能参与签到活动！': '累计充值,打码量,亏损不足，不能参与签到活动！',
  '累计充值,打码量不足，不能参与签到活动！': '累计充值,打码量不足，不能参与签到活动！',
  '累计充值,亏损不足，不能参与签到活动！': '累计充值,亏损不足，不能参与签到活动！',
  '累计打码量,亏损不足，不能参与签到活动！': '累计打码量,亏损不足，不能参与签到活动！',
  '累计充值不足，不能参与签到活动！': '累计充值不足，不能参与签到活动！',
  '累计打码量不足，不能参与签到活动！': '累计打码量不足，不能参与签到活动！',
  '累计亏损不足，不能参与签到活动！': '累计亏损不足，不能参与签到活动！',
  '活动时间内充值,打码量,亏损不足，不能参与签到活动！': '活动时间内充值,打码量,亏损不足，不能参与签到活动！',
  '活动时间内充值,打码量不足，不能参与签到活动！': '活动时间内充值,打码量不足，不能参与签到活动！',
  '活动时间内充值,亏损不足，不能参与签到活动！': '活动时间内充值,亏损不足，不能参与签到活动！',
  '活动时间内打码量,亏损不足，不能参与签到活动！': '活动时间内打码量,亏损不足，不能参与签到活动！',
  '活动时间内充值不足，不能参与签到活动！': '活动时间内充值不足，不能参与签到活动！',
  '活动时间内打码量不足，不能参与签到活动！': '活动时间内打码量不足，不能参与签到活动！',
  '活动时间内亏损不足，不能参与签到活动！': '活动时间内亏损不足，不能参与签到活动！',
  '每日充值未达到{num},每日打码量未达到{num2},签到失败': '每日充值未达到{num},每日打码量未达到{num2},签到失败',
  '每日充值未达到{num},签到失败': '每日充值未达到{num},签到失败',
  '每日打码量未达到{num},签到失败': '每日打码量未达到{num},签到失败',
  '网络状态不稳定，请刷新重试.': '网络状态不稳定，请刷新重试.',
  '充值满{num}可领取': '充值满{num}可领取',
  没有更多了: '没有更多了',
  '网络不给力，请重新尝试': '网络不给力，请重新尝试',
  '网络不给力，请检查网络 (500)': '网络不给力，请检查网络 (500)',
  '网络不给力，请检查网络 (502)': '网络不给力，请检查网络 (502)',
  '网络不给力，请检查网络 (503)': '网络不给力，请检查网络 (503)',
  '网络不给力，请检查网络 (504)': '网络不给力，请检查网络 (504)',
  '请求超时，请检查网络': '请求超时，请检查网络',
  '网络错误，请检查网络': '网络错误，请检查网络',
  '访问限制，请联系客服': '访问限制，请联系客服',
  '服务器繁忙,请稍后重试.': '服务器繁忙,请稍后重试.',
  加载下一页: '加载下一页',
  加载中: '加载中',
  在线客服: '在线客服',
  修改登录密码: '修改登录密码',
  修改资金密码: '修改资金密码',
  确认: '确认',
  检测中: '检测中',
  代理返点: '代理返点',
  该游戏暂停销售: '该游戏暂停销售',
  该游戏为内部测试: '该游戏为内部测试',
  '网络异常，请您联系客服': '网络异常，请您联系客服',
  '限额{min}到{max}': '限额{min}到{max}',
  '请选择PIX TYPE': '请选择 PIX TYPE',
  "游戏榜": '游戏榜',
  "盈利榜": '盈利榜',
  "进入": '进入',
  "全体代理收红包": "全体代理收红包",
  "第一次": "第一次",
  "第二次": "第二次",
  "第三次": "第三次",
  活动时间: '活动时间',
  年: '年',
  月: '月',
  日: '日',
  个: '个',
  '请绑定手机号码!': '请绑定手机号码!',
  '您的ip被限制不能参与答题，请联系客服!': '您的ip被限制不能参与答题，请联系客服!',
  '您当前不能参加答题活动，请联系客服!!!': '您当前不能参加答题活动，请联系客服!!!',
  '网站升级中, 敬请期待': '网站升级中, 敬请期待',
  '亲爱的朋友们': '亲爱的朋友们',
  '为了让你们访问更快更稳定，同时为您提供更高的品质服务': '为了让你们访问更快更稳定，同时为您提供更高的品质服务',
  '我们正在维护系统，给您造成不便，请您谅解': '我们正在维护系统，给您造成不便，请您谅解',
  '预计完成时间': '预计完成时间',
  '联系客服': '联系客服',
  '该游戏在您所在的国家/地区不可用': '该游戏在您所在的国家/地区不可用',
  '由于许可监管法，我们无法提供我们的服务': '由于许可监管法，我们无法提供我们的服务',
  '不在限制区域吗': '不在限制区域吗',
  '如果您使用代理服务或VPN访问，请尝试将其关闭': '如果您使用代理服务或VPN访问，请尝试将其关闭',
  '开始时间': '开始时间',
  前往联系在线客服: '前往联系在线客服',
  刷新页面重试: '刷新页面重试',
  取消: '取消',
  刷新: '刷新',
  '充值已提交，请稍后查看充值记录。确认是否到账': '充值已提交，请稍后查看充值记录。确认是否到账',
  提交失败: '提交失败',
  银行信息获取失败: '银行信息获取失败',
  '通道维护,请稍后再试': '通道维护,请稍后再试',
  支付通道不可用: '支付通道不可用',
  支付渠道不存在: '支付渠道不存在',
  关于我们: '关于我们',
  退出登录: '退出登录',
  原密码: '原密码',
  请输入原密码: '请输入原密码',
  新密码: '新密码',
  请输入新密码: '请输入新密码',
  确认新密码: '确认新密码',
  请输入确认新密码: '请输入确认新密码',
  两次密码输入的不一致: '两次密码输入的不一致',
  新密码不能跟原密码一致: '新密码不能跟原密码一致',
  密码修改成功: '密码修改成功',
  '密码规则为6-16位数字': '密码规则为6-16位数字',
  '密码规则为6-16个字母和数字组成': '密码规则为6-16个字母和数字组成',
  '密码规则为6-16位数字和大小写字母组成': '密码规则为6-16位数字和大小写字母组成',
  '密码规则为6-16位数字和大小写字母和特殊字符(~＠^#-%/.+:;=*)': '密码规则为6-16位数字和大小写字母和特殊字符(~＠^#-%/.+:;=*)',
  '密码规则为6-16位字符': '密码规则为6-16位字符',
  新资金密码需由6位纯数字组成: '新资金密码需由6位纯数字组成',
  修改联系方式: '修改联系方式',
  微信账号: '微信账号',
  请输入微信账号: '请输入微信账号',
  抖音账号: '抖音账号',
  请输入抖音账号: '请输入抖音账号',
  电子邮箱: '电子邮箱',
  请输入电子邮箱: '请输入电子邮箱',
  常用QQ: '常用QQ',
  请输入常用QQ: '请输入常用QQ',
  您输入的QQ号码无效: '您输入的QQ号码无效',
  您输入的微信无效: '您输入的微信无效',
  您输入的手机号码格式有误: '您输入的手机号码格式有误',
  您输入的电子邮箱格式有误: '您输入的电子邮箱格式有误',
  您输入的whatsApp有误: '您输入的whatsApp有误',
  您输入的facebook有误: '您输入的facebook有误',
  联系方式修改成功: '联系方式修改成功',
  加载智能验证失败: '加载智能验证失败',
  账号不能为空: '账号不能为空',
  密码不能为空: '密码不能为空',
  验证码不能为空: '验证码不能为空',
  智能验证未通过: '智能验证未通过',
  请输入正确的资金密码: '请输入正确的资金密码',
  请输入正确的真实姓名: '请输入正确的真实姓名',
  请输入正确的银行卡后4位: '请输入正确的银行卡后4位',
  特殊登陆验证: '特殊登陆验证',
  资金密码: '资金密码',
  默认资金密码为注册时的登陆密码: '默认资金密码为注册时的登陆密码',
  真实姓名: '真实姓名',
  默认银行卡后4位: '默认银行卡后4位',
  请输入默认银行卡后4位: '请输入默认银行卡后4位',
  '您也可输入支付宝(如包含‘＠’请输入该字符之前的后4位)或虚拟货币后4位': '您也可输入支付宝(如包含‘＠’请输入该字符之前的后4位)或虚拟货币后4位',
  安全检测中: '安全检测中',
  '账号不存在！请输入正确的账号': '账号不存在！请输入正确的账号',
  '您已经被锁定，禁止登录! 请联系管理员': '您已经被锁定，禁止登录! 请联系管理员',
  '您已被锁定，禁止登录！请您联系客服。': '您已被锁定，禁止登录！请您联系客服。',
  请输入合法的新资金密码: '请输入合法的新资金密码',
  '账号密码错误!': '账号密码错误!',
  '新密码需由6-16个字母或数字组成': '新密码需由6-16个字母或数字组成',
  '配置有误,请联系客服!': '配置有误,请联系客服!',
  请求没有返回任何数据: '请求没有返回任何数据',
  退出成功: '退出成功',
  密码登录: '密码登录',
  短验登录: '短验登录',
  邮箱登录: '邮箱登录',
  邮箱密码登录: '邮箱密码登录',
  '[验证码]不能为空': '[验证码]不能为空',
  '[手机号]不能为空': '[手机号]不能为空',
  '请输入正确的[邮箱账号]': '请输入正确的[邮箱账号]',
  '请输入[邮箱验证码]': '请输入[邮箱验证码]',
  '[密码]不能为空': '[密码]不能为空',
  '请输入[账号]': '请输入[账号]',
  获取验证码: '获取验证码',
  邮箱账号不能为空: '邮箱账号不能为空',
  发送成功: '发送成功',
  手机号未填写: '手机号未填写',
  注册: '注册',
  账号: '账号',
  请输入账号: '请输入账号',
  邮箱: '邮箱',
  请输入邮箱账号: '请输入邮箱账号',
  邮箱验证码: '邮箱验证码',
  请输入邮箱验证码: '请输入邮箱验证码',
  手机号: '手机号',
  请输入手机号: '请输入手机号',
  验证码: '验证码',
  请输入手机号验证码: '请输入手机号验证码',
  邮箱账号: '邮箱账号',
  密码: '密码',
  请输入密码: '请输入密码',
  确认密码: '确认密码',
  请再次输入密码: '请再次输入密码',
  请输入验证码: '请输入验证码',
  请输入真实姓名: '请输入真实姓名',
  昵称: '昵称',
  请输入昵称: '请输入昵称',
  请输入QQ号: '请输入QQ号',
  请输入邮箱号: '请输入邮箱号',
  请输入Zalo: '请输入Zalo',
  请输入Line: '请输入Line',
  请输入Facebook: '请输入Facebook',
  请输入WhatsApp: '请输入WhatsApp',
  邀请码: '邀请码',
  请输入邀请码: '请输入邀请码',
  请输入资金密码: '请输入资金密码',
  密码注册: '密码注册',
  短验注册: '短验注册',
  邮箱注册: '邮箱注册',
  '抱歉！该会员账号已被注册': '抱歉！该会员账号已被注册',
  请勿重复提交: '请勿重复提交',
  '5～12位数字和字母': '5～12位数字和字母',
  可以注册: '可以注册',
  '请填写[密码]': '请填写[密码]',
  '[密码]长度不能小于6位': '[密码]长度不能小于6位',
  '[密码]长度不能超过16位': '[密码]长度不能超过16位',
  '[资金密码]规则为6-16位数字': '[资金密码]规则为6-16位数字',
  '[资金密码]规则6位数字': '[资金密码]规则6位数字',
  '[资金密码]需由6-16个字母和数字组成': '[资金密码]需由6-16个字母和数字组成',
  '[资金密码]需由6-16位数字和大小写字母组成': '[资金密码]需由6-16位数字和大小写字母组成',
  '[资金密码]需由6-16位数字和大小写字母和特殊字符(~＠^#-%/.+:;=*)': '[资金密码]需由6-16位数字和大小写字母和特殊字符(~＠^#-%/.+:;=*)',
  '请填写[确认密码]': '请填写[确认密码]',
  两次输入的密码不一致: '两次输入的密码不一致',
  '请填写[真实姓名]': '请填写[真实姓名]',
  '请输入50个以内字符[真实姓名]': '请输入50个以内字符[真实姓名]',
  '请输入正确格式[真实姓名]': '请输入正确格式[真实姓名]',
  '请填写[昵称]': '请填写[昵称]',
  '请输入32个以内字符[昵称]': '请输入32个以内字符[昵称]',
  '请输入正确格式[昵称]': '请输入正确格式[昵称]',
  '请填写正确[手机号]': '请填写正确[手机号]',
  '请填写[QQ]': '请填写[QQ]',
  '请填写正确的[QQ]': '请填写正确的[QQ]',
  '请输入正确[邮箱]格式': '请输入正确[邮箱]格式',
  '请填写[Zalo]': '请填写[Zalo]',
  '[Zalo]为6-11位纯数字': '[Zalo]为6-11位纯数字',
  '请填写[Line]': '请填写[Line]',
  '请填写[Facebook]': '请填写[Facebook]',
  '[Facebook]的长度为6-60': '[Facebook]的长度为6-60',
  '请填写[WhatsApp]': '请填写[WhatsApp]',
  '[WhatsApp]为6-15位纯数字': '[WhatsApp]为6-15位纯数字',
  '请输入正确的[验证码]': '请输入正确的[验证码]',
  '请填写[邀请码]': '请填写[邀请码]',
  '请填写[账号]': '请填写[账号]',
  '请填写[邮箱]': '请填写[邮箱]',
  '请填写[邮箱验证码]': '请填写[邮箱验证码]',
  '请填写[手机号]': '请填写[手机号]',
  '请填写[验证码]': '请填写[验证码]',
  成功注册: '成功注册',
  请输入WhatsApp号码: '请输入WhatsApp号码',
  请输入Facebook账号: '请输入Facebook账号',
  '之前的充值申请正在处理中，请勿重复申请': '之前的充值申请正在处理中，请勿重复申请',
  记住账号: '记住账号',
  复制邀请链接: '复制邀请链接',
  复制邀请码: '复制邀请码',
  更多: '更多',
  登录: '登录',
  没有账号: '没有账号',
  立即注册: '立即注册',
  忘记密码: '忘记密码',
  '配置有误，请联系客服！！！': '配置有误，请联系客服！！！',
  充值渠道: '充值渠道',
  '待支付订单过多，请先绑定银行卡后再次充值': '待支付订单过多，请先绑定银行卡后再次充值',
  请选择充值渠道: '请选择充值渠道',
  快速充值通道: '快速充值通道',
  更新提示: '更新提示',
  当前版本号: '当前版本号',
  最新版本号: '最新版本号',
  本次更新内容: '本次更新内容',
  稍后更新: '稍后更新',
  官网下载: '官网下载',
  下载: '下载',
  下载APP: '下载APP',
  立即更新: '立即更新',
  '即将进入支付页面，请确认': '即将进入支付页面，请确认',
  '正在分配客服，请确认': '正在分配客服，请确认',
  转账: '转账',
  账户类型: '账户类型',
  历史记录: '历史记录',
  钱包地址: '钱包地址',
  '打码量限制{num}': '尊敬的会员，您的要求打码量为{num}大于0，抱歉不能申请提现',
  '单日提现金额最高:{num}！': '单日提现金额最高:{num}！',
  '单日最多提现{num}次': '单日最多提现{num}次',
  '今日可提现额度为:{num}': '今日可提现额度为:{num}',
  绑定: '绑定',
  提现方式: '提现方式',
  银行卡: '银行卡',
  可提现金余额: '可提现金余额',
  添加: '添加',
  到账金额: '到账金额',
  提现: '提现',
  充值: '充值',
  记录: '记录',
  搜索: '搜索',
  提示: '提示',
  提交: '提交',
  充值数量: '充值数量',
  虚拟币数量: '虚拟币数量',
  存款汇率: '存款汇率',
  实际到账: '实际到账',
  请输入充值数量: '请输入充值数量',
  请输入虚拟币数量: '请输入虚拟币数量',
  充值金额: '充值金额',
  请输入金额: '请输入金额',
  优惠比例: '优惠比例',
  收款机构: '收款机构',
  复制: '复制',
  收款账号: '收款账号',
  请输入充值金额: '请输入充值金额',
  收款户名: '收款户名',
  汇款银行名称: '汇款银行名称',
  请输入汇款银行名称: '请输入汇款银行名称',
  汇款人姓名: '汇款人姓名',
  汇款卡号后4位: '汇款卡号后4位',
  请输入汇款卡号后4位: '请输入汇款卡号后4位',
  备注: '备注',
  请输入备注: '请输入备注',
  支付截图: '支付截图',
  请输入汇款人姓名: '请输入汇款人姓名',
  付款人姓名: '付款人姓名',
  请输入微信号的名称: '请输入微信号的名称',
  订单后6位: '订单后6位',
  请输入订单号后6位: '请输入订单号后6位',
  请输入QQ账号: '请输入QQ账号',
  请输入云闪付的账号: '请输入云闪付的账号',
  资金明细: '资金明细',
  信息中心: '信息中心',
  系统公告: '系统公告',
  我的消息: '我的消息',
  未读信息: '未读信息',
  消息最多保存7天: '消息最多保存7天',
  全部删除: '全部删除',
  全部已读: '全部已读',
  收件箱: '收件箱',
  问题反馈: '问题反馈',
  '请输入您的问题，我们会第一时间回复，谢谢': '请输入您的问题，我们会第一时间回复，谢谢',
  详情: '详情',
  客服QQ: '客服QQ',
  客服微信: '客服微信',
  官方网址: '官方网址',
  官方二维码: '官方二维码',
  '这是您成为会员的第{num}天': '这是您成为会员的第{num}天',
  我的钱包: '我的钱包',
  复制成功: '复制成功',
  复制失败: '复制失败',
  '确定要退出登录吗？': '确定要退出登录吗？',
  '已有账号,去登录': '已有账号,去登录',
  '金额在{a}~{b}之间': '金额在{a}~{b}之间',
  '温馨提示：充值金额不能大于{n}金币': '温馨提示：充值金额不能大于{n}金币',
  '您暂未绑定任何银行卡，请前往绑定！': '您暂未绑定任何银行卡，请前往绑定！',
  绑定银行卡: '绑定银行卡',
  '您暂未绑定PixPay，请前往绑定！': '您暂未绑定PixPay，请前往绑定！',
  绑定PixPay: '绑定PixPay',
  '您暂未绑定PicPay，请前往绑定！': '您暂未绑定PicPay，请前往绑定！',
  绑定PicPay: '绑定PicPay',
  '您暂未绑定支付宝，请前往绑定！': '您暂未绑定支付宝，请前往绑定！',
  绑定支付宝: '绑定支付宝',
  '您暂未绑定任何虚拟币，请前往绑定！': '您暂未绑定任何虚拟币，请前往绑定！',
  绑定虚拟货币: '绑定虚拟货币',
  '您暂未绑定UPI，请前往绑定！': '您暂未绑定UPI，请前往绑定！',
  绑定UPI: '绑定UPI',
  '您暂未绑定GoPay，请前往绑定！': '您暂未绑定GoPay，请前往绑定！',
  绑定GoPay: '绑定GoPay',
  '您暂未绑定OKPay，请前往绑定！': '您暂未绑定OKPay，请前往绑定！',
  绑定OKPay: '绑定OKPay',
  '您暂未绑定ToPay，请前往绑定！': '您暂未绑定ToPay，请前往绑定！',
  绑定ToPay: '绑定ToPay',
  账户金币: '账户金币',
  全提: '全提',
  提现金币: '提现金币',
  确认提现: '确认提现',
  国家: '国家',
  银行名称: '银行名称',
  开户行网点: '开户行网点',
  请输入开户行网点: '请输入开户行网点',
  银行卡号: '银行卡号',
  请输入银行卡号: '请输入银行卡号',
  预留手机号: '预留手机号',
  请输入预留手机号: '请输入预留手机号',
  '银行账号为{min}~{max}位': '银行账号为{min}~{max}位',
  '请输入{a}': '请输入{a}',
  确定绑定: '确定绑定',
  筛选: '筛选',
  交易类型: '交易类型',
  重置: '重置',
  冠军投注: '冠军投注',
  截止: '截止',
  '提交成功，请等待系统审核': '提交成功，请等待系统审核',
  提交结果: '提交结果',
  返回首页: '返回首页',
  身份认证: '身份认证',
  实名认证: '实名认证',
  证件类型: '证件类型',
  请输入国家: '请输入国家',
  请输入姓名: '请输入姓名',
  证件号码: '证件号码',
  请输入证件号码: '请输入证件号码',
  证件正面: '证件正面',
  证件背面: '证件背面',
  协议: '协议',
  添加OKPay: '添加OKPay',
  OKPay账号: 'OKPay账号',
  请输入OKPay账号: '请输入OKPay账号',
  设为默认绑定OKPay: '设为默认绑定OKPay',
  添加PicPay: '添加PicPay',
  PicPay账号: 'PicPay账号',
  请输入PicPay账号: '请输入PicPay账号',
  设为默认绑定pcipay: '设为默认绑定pcipay',
  添加PixPay: '添加PixPay',
  CPF: 'CPF',
  请输入CPF号码: '请输入CPF号码',
  请输入PixKey: '请输入 PIX KEY',
  PixKey: 'PixKey',
  PixType: 'PixType',
  设为默认绑定pixpay: '设为默认绑定pixpay',
  隐私政策: '隐私政策',
  复制地址: '复制地址',
  保存二维码: '保存二维码',
  TXID: 'TXID',
  请输入TXID: '请输入TXID',
  添加ToPay: '添加ToPay',
  ToPay账号: 'ToPay账号',
  请输入ToPay账号: '请输入ToPay账号',
  设为默认绑定Topay: '设为默认绑定Topay',
  添加UPI: '添加UPI',
  UPI账号: 'UPI账号',
  请输入UPI账号: '请输入UPI账号',
  设为默认绑定upi: '设为默认绑定upi',
  添加虚拟币: '添加虚拟币',
  协议类型: '协议类型',
  USDT地址: 'USDT地址',
  请把地址粘贴在这里: '请把地址粘贴在这里',
  上传二维码: '上传二维码',
  设为默认绑定虚拟货币: '设为默认绑定虚拟货币',
  添加支付宝: '添加支付宝',
  支付宝账号: '支付宝账号',
  请输入支付宝账号: '请输入支付宝账号',
  设为默认绑定支付宝: '设为默认绑定支付宝',
  投注详情: '投注详情',
  追号详情: '追号详情',
  撤单: '撤单',
  '第{num}期': '第{num}期',
  订单金额: '订单金额',
  中奖金额: '中奖金额',
  返点金额: '返点金额',
  订单状态: '订单状态',
  已撤单: '已撤单',
  已出票: '已出票',
  未中奖: '未中奖',
  已中奖: '已中奖',
  返还金额: '返还金额',
  盈利金额: '盈利金额',
  下单时间: '下单时间',
  开奖结果: '开奖结果',
  平台注单号: '平台注单号',
  金币: '金币',
  注: '注',
  投注时间: '投注时间',
  剩余期数: '剩余期数',
  累计中奖: '累计中奖',
  中奖停止: '中奖停止',
  利润率追号: '利润率追号',
  是: '是',
  否: '否',
  期号: '期号',
  开奖号码: '开奖号码',
  图片上传中: '图片上传中',
  充值提交成功: '充值提交成功',
  请登录: '请登录',
  充值序列号: '充值序列号',
  '请耐心等待，客服即将为您审核充值。': '请耐心等待，客服即将为您审核充值。',
  收藏失败: '收藏失败',
  取消收藏失败: '取消收藏失败',
  '亲，请先登录哦': '亲，请先登录哦',
  操作过于频繁: '操作过于频繁',
  请上传支付截图: '请上传支付截图',
  收款二维码: '收款二维码',
  '(长按二维码保存到本地)': '(长按二维码保存到本地)',
  '扫码支付后，请填写充值金币，并点击提交，': '扫码支付后，请填写充值金币，并点击提交，',
  '否则无法为您上分！': '否则无法为您上分！',
  转账步骤: '转账步骤',
  请填写您的汇款信息: '请填写您的汇款信息',
  付款支付宝真实姓名: '付款支付宝真实姓名',
  '付款时所用的支付宝账号(选填)': '付款时所用的支付宝账号(选填)',
  本次充值的金币: '本次充值的金币',
  订单号后6位: '订单号后6位',
  付款时微信号的名称: '付款时微信号的名称',
  付款时的QQ账号: '付款时的QQ账号',
  付款时云闪付的账号: '付款时云闪付的账号',
  '付款时所用的微信账号(选填)': '付款时所用的微信账号(选填)',
  请输入交易订单号后6位: '请输入交易订单号后6位',
  请输入订单付款凭证号后6位: '请输入订单付款凭证号后6位',
  汇款银行卡所属的银行: '汇款银行卡所属的银行',
  汇款时使用银行卡的户名: '汇款时使用银行卡的户名',
  付款账户地址: '付款账户地址',
  汇款时所用银行卡卡号的后4位: '汇款时所用银行卡卡号的后4位',
  请选择存款方式: '请选择存款方式',
  线下充值提交成功: '线下充值提交成功',
  '(用于填写备注或附言)': '(用于填写备注或附言)',
  请输入正确的邮箱账号: '请输入正确的邮箱账号',
  邮箱格式错误: '邮箱格式错误',
  '该设备当天发送邮件次数已经超限{key}次': '该设备当天发送邮件次数已经超限{key}次',
  该邮箱号码当天接收邮件次数已经超限: '该邮箱号码当天接收邮件次数已经超限',
  '邮箱服务有误，请联系客服处理': '邮箱服务有误，请联系客服处理',
  '没有可发送的邮箱配置,请联系客服': '没有可发送的邮箱配置,请联系客服',
  '相同IP参与红包雨次数过多！': '相同IP参与红包雨次数过多！',
};

const main = {
  '请选择{n}进行转账 每次转账请刷新APP获取最新地址，请勿保存原地址': '请选择{n}进行转账 每次转账请刷新APP获取最新地址，请勿保存原地址',
  '您需要{m}存款和{n}流水升级至': '您需要{m}存款和{n}流水升级至',
  '进入房间失败，可能已被拒绝': '进入房间失败，可能已被拒绝',
  获取房间信息: '获取房间信息',
  '第{num}期': '第{num}期',
  银行转账入款: '银行转账入款',
  线上支付: '线上支付',
  我的佣金: '我的佣金',
  备用网址: '备用网址',
  备用域名: '备用域名',
  我的下级: '我的下级',
  代理系统: '代理系统',
  代理教程: '代理教程',
  我的分享: '我的分享',
  代理相关: '代理相关',
  '试玩账号不能进入该游戏、请注册正式会员': '试玩账号不能进入该游戏、请注册正式会员',
  彩种信息缺失: '彩种信息缺失',
  暂停销售: '暂停销售',
  停止销售: '停止销售',
  未获取到三方平台地址: '未获取到三方平台地址',
  该游戏为内部测试: '该游戏为内部测试',
  '游戏未开启,尽请期待': '游戏未开启,尽请期待',
  全部彩票: '全部彩票',
  彩种: '彩种',
  投注结果: '投注结果',
  红包: '红包',
  默认查询全部会员: '默认查询全部会员',
  查询单个会员: '查询单个会员',
  释放刷新: '释放刷新',
  下拉刷新: '下拉刷新',
  没有更多数据了: '没有更多数据了',
  类型: '类型',
  全部: '全部',
  提现记录: '提现记录',
  充值记录: '充值记录',
  佣金记录: '佣金记录',
  查询: '查询',
  金额: '金额',
  上一级返佣: '上一级返佣',
  上二级返佣: '上二级返佣',
  上三级返佣: '上三级返佣',
  暂无数据: '暂无数据',
  棋牌投注: '棋牌投注',
  彩票投注: '彩票投注',
  真人投注: '真人投注',
  电子投注: '电子投注',
  捕鱼投注: '捕鱼投注',
  体育投注: '体育投注',
  国际彩票: '国际彩票',
  已加载全部内容: '已加载全部内容',
  未结算: '未结算',
  已结算: '已结算',
  '标记的为默认出款渠道，点击{a}可修改为默认出款渠道！': '标记的为默认出款渠道，点击{a}可修改为默认出款渠道！',
  热门游戏: '热门游戏',
  全体红包: '全体红包',
  红包列表: '红包列表',
  中奖名单: '中奖名单',
  距活动结束: '距活动结束',
  红包类型: '红包类型',
  中奖时间: '中奖时间',
  抢: '抢',
  系统派送: '系统派送',
  '您的当前积分不足，无法进行抽奖': '您的当前积分不足，无法进行抽奖',
  '正在初始化积分，请稍后在试，请联系客服！': '正在初始化积分，请稍后在试，请联系客服！',
  '您当前不能参幸运大转盘，请联系客服！！！': '您当前不能参幸运大转盘，请联系客服！！！',
  '您的电话号码被限制不能幸运大转盘，请联系客服！': '您的电话号码被限制不能幸运大转盘，请联系客服！',
  '当前{key}期已封': '当前{key}期已封',
  '余额低于{num}，暂时无法游戏': '余额低于{num}，暂时无法游戏',
  '标记的为默认出款渠道，点击{name}可修改为默认出款渠道！': '标记的为默认出款渠道，点击{name}可修改为默认出款渠道！',
  '您暂未绑定{name}，请前往绑定': '您暂未绑定{name}，请前往绑定',
  要求打码量: '要求打码量',
  万币线下充值: '万币线下充值',
  '标记的为默认出款渠道，点击万币可修改为默认出款渠道！': '标记的为默认出款渠道，点击万币可修改为默认出款渠道！',
  '[万币账号]不能为空': '[万币账号]不能为空',
  '万币账号': '万币账号',
  '请输入万币账号': '请输入万币账号',
  '添加万币': '添加万币',
  万币: '万币',
  '万币(线下)': '万币(线下)',
  '您暂未绑定万币，请前往绑定！': '您暂未绑定万币，请前往绑定！',
  充值中: '充值中',
  首充大礼包说明: '首充大礼包说明',
  '亏损满{num}金币可领取': '亏损满{num}金币可领取',
  分享领彩金: '分享领彩金',
  首充大礼包: '首充大礼包',
  渠道优惠: '渠道优惠',
  borrowTypeIntro: '目前支持使用优惠活动的奖励金额抵扣借呗待还金额，系统将在借款后{date}天扣除，支持的活动类型包含',
  '金额不能大于{key}': '金额不能大于{key}',
  '金额不能小于{key}': '金额不能小于{key}',
  '只能使用去中心化钱包投注，若使用交易所钱包将无法投注，也无法追回': '只能使用去中心化钱包投注，若使用交易所钱包将无法投注，也无法追回',
  历史开奖号码: '历史开奖号码',
  下一轮服务端哈希: '下一轮服务端哈希',
  验证: '验证',
  服务端哈希: '服务端哈希',
  请先设置您的提币地址: '请先设置您的提币地址',
  请先设置您的提款账号: '请先设置您的提款账号',
  '下回合在{key}秒后开始': '下回合在{key}秒后开始',
  兑现成功: '兑现成功',
  兑现失败: '兑现失败',
  游戏下单: '游戏下单',
  取消下单: '取消下单',
  输: '输',
  玩家: '玩家',
  客户端种子: '客户端种子',
  计算: '计算',
  最终结果: '最终结果',
  种子到十六进制: '种子到十六进制',
  十六进制到十进制: '十六进制到十进制',
  开始计算: '开始计算',
  手动: '手动',
  兑现于: '兑现于',
  获得利润: '获得利润',
  控制: '控制',
  排行榜: '排行榜',
  若赢: '若赢',
  若输: '若输',
  增加: '增加',
  止盈: '止盈',
  止损: '止损',
  开始自动投注: '开始自动投注',
  游戏信息: '游戏信息',
  加倍投注额: '加倍投注额',
  减半投注额: '减半投注额',
  零数投注额: '零数投注额',
  会员任务: '会员任务',
  棋牌任务: '棋牌任务',
  电子任务: '电子任务',
  捕鱼任务: '捕鱼任务',
  充值大礼包: '充值大礼包',
  游戏任务: '游戏任务',
  加1注机选: '加1注机选',
  加5注机选: '加5注机选',
  加1注自选: '加1注自选',
  添加自选号码: '添加自选号码',
  '普通投注，': '普通投注，',
  普通投注: '普通投注',
  方案倍数: '方案倍数',
  追号投注: '追号投注',
  追号订单: '追号订单',
  普通订单: '普通订单',
  '(可撤单)': '(可撤单)',
  追号类型: '追号类型',
  追号期数: '追号期数',
  追号: '追号',
  利润率追号: '利润率追号',
  同倍追号: '同倍追号',
  翻倍追号: '翻倍追号',
  连购期数: '连购期数',
  起始倍数: '起始倍数',
  最低收益率: '最低收益率',
  生成追号计划: '生成追号计划',
  选择: '选择',
  开奖期号: '开奖期号',
  倍数: '倍数',
  时间: '时间',
  中奖后停止追号: '中奖后停止追号',
  用户: '用户',
  下注金额: '下注金额',
  请输入6位纯数字组成的资金密码: '请输入6位纯数字组成的资金密码',
  活动详细说明: '活动详细说明',
  进入第三方游戏: '进入第三方游戏',
  申请提交: '申请提交',
  审核通过: '审核通过',
  审核拒绝: '审核拒绝',
  自助申请优惠: '自助申请优惠',
  审核进度查询: '审核进度查询',
  电话号码: '电话号码',
  一分钟只能回收一次: '一分钟只能回收一次',
  取消收藏成功: '取消收藏成功',
  收藏成功: '收藏成功',
  投注金额: '投注金额',
  自定义任务: '自定义任务',
  自助领取: '自助领取',
  已获得: '已获得',
  已发放至账户: '已发放至账户',
  前领取: '前领取',
  请登录后查看: '请登录后查看',
  立即登录: '立即登录',
  亲爱的用户你已获得: '亲爱的用户你已获得',
  奖励资格: '奖励资格',
  赶紧去领取吧: '赶紧去领取吧',
  当前暂无活动: '当前暂无活动',
  尊敬的用户: '尊敬的用户',
  恭喜你获得: '恭喜你获得',
  每日盈利: '每日盈利',
  每日亏损: '每日亏损',
  会员须: '会员须',
  累计充值金额: '累计充值金额',
  打码倍数: '打码倍数',
  满足要求可领取彩金奖励: '满足要求可领取彩金奖励',
  累计充值天数: '累计充值天数',
  单日充值金额: '单日充值金额',
  连续充值天数: '连续充值天数',
  单日打码倍数: '单日打码倍数',
  单日首充金额: '单日首充金额',
  首充金额: '首充金额',
  会员须在: '会员须在',
  '的游戏，累计打码金额': '的游戏，累计打码金额',
  '的游戏，累计彩票打码金额': '的游戏，累计彩票打码金额',
  '满足要求可领取彩金奖励（不包含已撤单的彩票投注）': '满足要求可领取彩金奖励（不包含已撤单的彩票投注）',
  '的游戏，累计电子打码金额': '的游戏，累计电子打码金额',
  '的游戏，累计真人打码金额': '的游戏，累计真人打码金额',
  '的游戏，累计体育打码金额': '的游戏，累计体育打码金额',
  '的游戏，累计捕鱼打码金额': '的游戏，累计捕鱼打码金额',
  '的游戏，累计棋牌打码金额': '的游戏，累计棋牌打码金额',
  '的游戏，打码金额': '的游戏，打码金额',
  打码天数: '打码天数',
  '天，满足要求可领取彩金奖励': '天，满足要求可领取彩金奖励',
  '的游戏，彩票打码金额': '的游戏，彩票打码金额',
  累计彩票打码天数: '累计彩票打码天数',
  '的游戏，电子打码金额': '的游戏，电子打码金额',
  累计电子打码天数: '累计电子打码天数',
  '的游戏，真人打码金额': '的游戏，真人打码金额',
  累计真人打码天数: '累计真人打码天数',
  '的游戏，体育打码金额': '的游戏，体育打码金额',
  累计体育打码天数: '累计体育打码天数',
  '的游戏，捕鱼打码金额': '的游戏，捕鱼打码金额',
  累计捕鱼打码天数: '累计捕鱼打码天数',
  '的游戏，棋牌打码金额': '的游戏，棋牌打码金额',
  累计棋牌打码天数: '累计棋牌打码天数',
  '的游戏，单日打码金额': '的游戏，单日打码金额',
  连续打码天数: '连续打码天数',
  '的游戏，单日彩票打码金额': '的游戏，单日彩票打码金额',
  连续彩票打码天数: '连续彩票打码天数',
  '的游戏，单日电子打码金额': '的游戏，单日电子打码金额',
  连续电子打码天数: '连续电子打码天数',
  '的游戏，单日真人打码金额': '的游戏，单日真人打码金额',
  连续真人打码天数: '连续真人打码天数',
  '的游戏，单日体育打码金额': '的游戏，单日体育打码金额',
  连续体育打码天数: '连续体育打码天数',
  '的游戏，单日捕鱼打码金额': '的游戏，单日捕鱼打码金额',
  连续捕鱼打码天数: '连续捕鱼打码天数',
  '的游戏，单日棋牌打码金额': '的游戏，单日棋牌打码金额',
  连续棋牌打码天数: '连续棋牌打码天数',
  日: '日',
  每日: '每日',
  每月: '每月',
  每周一: '每周一',
  每周二: '每周二',
  每周三: '每周三',
  每周四: '每周四',
  每周五: '每周五',
  每周六: '每周六',
  每周日: '每周日',
  累计打码金额: '累计打码金额',
  累计彩票打码金额: '累计彩票打码金额',
  累计电子打码金额: '累计电子打码金额',
  累计真人打码金额: '累计真人打码金额',
  累计体育打码金额: '累计体育打码金额',
  累计捕鱼打码金额: '累计捕鱼打码金额',
  累计棋牌打码金额: '累计棋牌打码金额',
  累计打码天数: '累计打码天数',
  累计充值: '累计充值',
  连续充值: '连续充值',
  首充: '首充',
  单日首充: '单日首充',
  累计打码: '累计打码',
  累计彩票打码: '累计彩票打码',
  累计电子打码: '累计电子打码',
  累计真人打码: '累计真人打码',
  累计体育打码: '累计体育打码',
  累计捕鱼打码: '累计捕鱼打码',
  累计棋牌打码: '累计棋牌打码',
  连续打码: '连续打码',
  连续彩票打码: '连续彩票打码',
  连续电子打码: '连续电子打码',
  连续真人打码: '连续真人打码',
  连续体育打码: '连续体育打码',
  连续捕鱼打码: '连续捕鱼打码',
  连续棋牌打码: '连续棋牌打码',
  会员任务不存在: '会员任务不存在',
  会员任务无效: '会员任务无效',
  当前用户不存在: '当前用户不存在',
  当前用户等级不存在: '当前用户等级不存在',
  账户被禁用请联系客服处理: '账户被禁用请联系客服处理',
  不可重复领取: '不可重复领取',
  会员任务领取金额失败: '会员任务领取金额失败',
  '当前条件没有满足,不能领取': '当前条件没有满足,不能领取',
  下注成功: '下注成功',
  投注成功: '投注成功',
  投注失败: '投注失败',
  注单确认中: '注单确认中',
  删除: '删除',
  限额: '限额',
  团队游戏: '团队游戏',
  我的收藏: '我的收藏',
  '由于注单延迟，投注记录数据彩金会有延迟 !!!': '由于注单延迟，投注记录数据彩金会有延迟 !!!',
  '充值金币: ': '充值金币: ',
  '银行名称: ': '银行名称: ',
  联系: '联系',
  '由于注单延迟，投注记录数据彩金会有延迟!!!': '由于注单延迟，投注记录数据彩金会有延迟!!!',
  筛选订单: '筛选订单',
  红包投注: '红包投注',
  投注次数: '投注次数',
  投注金币: '投注金币',
  中奖金币: '中奖金币',
  投注盈亏: '投注盈亏',
  返还金币: '返还金币',
  幸运注单: '幸运注单',
  幸运注单活动说明: '幸运注单活动说明',
  活动说明: '活动说明',
  立即领取: '立即领取',
  幸运注单手动领取: '幸运注单手动领取',
  幸运注单自动发放: '幸运注单自动发放',
  幸运注单次日自动发放: '幸运注单次日自动发放',
  '幸运注单，订单号：': '幸运注单，订单号：',
  ',幸运注单号：': ',幸运注单号：',
  次日自动发放: '次日自动发放',
  '领取失败，请重试': '领取失败，请重试',
  手动领取: '手动领取',
  投注惊喜享不停: '投注惊喜享不停',
  代理报表: '代理报表',
  团队盈亏: '团队盈亏',
  团队日结: '团队日结',
  团队充值: '团队充值',
  会员余额: '会员余额',
  请输入查询会员名: '请输入查询会员名',
  全部下级: '全部下级',
  会员名称: '会员名称',
  自己: '自己',
  团队类型: '团队类型',
  直属下级: '直属下级',
  团队余额汇总: '团队余额汇总',
  团队人数: '团队人数',
  团队提现: '团队提现',
  线下充值订单: '线下充值订单',
  收款人信息: '收款人信息',
  请输入IFSC: '请输入IFSC',
  '您尚未绑定虚拟货币钱包地址，请先绑定后再取款': '您尚未绑定虚拟货币钱包地址，请先绑定后再取款',
  记住密码: '记住密码',
  选择分区号: '选择分区号',
  当前选择: '当前选择',
  邮箱未注册: '邮箱未注册',
  邮箱已经被注册: '邮箱已经被注册',
  '该邮箱已认证，请重新输入': '该邮箱已认证，请重新输入',
  '邮箱格式错误！': '邮箱格式错误！',
  本站未开通邮箱登录: '本站未开通邮箱登录',
  本站未开通邮箱验证码登录: '本站未开通邮箱验证码登录',
  本站未开通邮箱验证码注册: '本站未开通邮箱验证码注册',
  该邮箱号未注册: '该邮箱号未注册',
  本站未开通邮箱密码登录: '本站未开通邮箱密码登录',
  未开通邮箱登录: '未开通邮箱登录',
  邮箱验证码不能为空: '邮箱验证码不能为空',
  邮箱验证码错误: '邮箱验证码错误',
  '验证码不正确！': '验证码不正确！',
  '邮箱验证码已过期，或者不存在': '邮箱验证码已过期，或者不存在',
  '您暂未绑定OKPay，请前往绑定！': '您暂未绑定OKPay，请前往绑定！',
  绑定OKPay: '绑定OKPay',
  '您暂未绑定ToPay，请前往绑定！': '您暂未绑定ToPay，请前往绑定！',
  绑定ToPay: '绑定ToPay',
  '标记的为默认出款渠道，点击OKPay可修改为默认出款渠道！': '标记的为默认出款渠道，点击OKPay可修改为默认出款渠道！',
  '标记的为默认出款渠道，点击ToPay可修改为默认出款渠道！': '标记的为默认出款渠道，点击ToPay可修改为默认出款渠道！',
  添加ToPay: '添加ToPay',
  ToPay账号: 'ToPay账号',
  请输入ToPay账号: '请输入ToPay账号',
  设为默认绑定Topay: '设为默认绑定Topay',
  添加OKPay: '添加OKPay',
  OKPay账号: 'OKPay账号',
  请输入OKPay账号: '请输入OKPay账号',
  设为默认绑定OKPay: '设为默认绑定OKPay',
  下单时间: '下单时间',
  下次吧: '下次吧',
  下注: '下注',
  下注内容: '下注内容',
  下注后结余: '下注后结余',
  下注开始的时间: '下注开始的时间',
  下注时间: '下注时间',
  下注类型: '下注类型',
  下注金币: '下注金币',
  下注额: '下注额',
  下级代理: '下级代理',
  下级列表: '下级列表',
  请选择追号类型: '请选择追号类型',
  请设置追号期数: '请设置追号期数',
  请设置起始倍数: '请设置起始倍数',
  获取期号信息失败: '获取期号信息失败',
  利润率追号一次只能追一个号码: '利润率追号一次只能追一个号码',
  请设置利润率: '请设置利润率',
  '利润率错误,本次投注无法达到该利润率！': '利润率错误,本次投注无法达到该利润率！',
  请设置间隔期数: '请设置间隔期数',
  请设置间隔期之间的倍数: '请设置间隔期之间的倍数',
  投注金额不能大于99999999元: '投注金额不能大于99999999元',
  '当前追号期数为0期，请重新设置追号计划': '当前追号期数为0期，请重新设置追号计划',
  亏损救援金: '亏损救援金',
  亏损满: '亏损满',
  '亏损满{num}金币可以领取': '亏损满{num}金币可以领取',
  '分享{key}个好友（{day}累计）': '分享{key}个好友（{day}累计）',
  有效下注金币: '有效下注金币',
  '有效投注满{num}金币可领取': '有效投注满{num}金币可领取',
  有效投注额: '有效投注额',
  '每日亏损任务，每日结算，隔天可领，每天24点重置更新.': '每日亏损任务，每日结算，隔天可领，每天24点重置更新.',
  '每日充值任务，实时结算，实时可领，每天24点重置更新。': '每日充值任务，实时结算，实时可领，每天24点重置更新。',
  '每日虚拟币充值任务，实时结算，实时可领，每天24点重置更新。': '每日虚拟币充值任务，实时结算，实时可领，每天24点重置更新。',
  '每日打码任务，实时结算，实时可领，每天24点重置更新。': '每日打码任务，实时结算，实时可领，每天24点重置更新。',
  每日投注: '每日投注',
  活动审核拒绝: '活动审核拒绝',
  活动审核通过: '活动审核通过',
  '活动时间内充值/打码量不足，不能参与红包雨活动！': '活动时间内充值/打码量不足，不能参与红包雨活动！',
  "点击个人中心-投注记录'进行查看投注记录。'": "点击个人中心-投注记录'进行查看投注记录。'",

};

const other = {
  赔率说明: '赔率说明',
  普通房: '普通房',
  '最低{n}起': '最低{n}起',
  贵宾房: '贵宾房',
  高赔率: '高赔率',
  缺少用户id: '缺少用户id',
  缺少token: '缺少token',
  用户信息失败: '用户信息失败',
  没有对应彩种: '没有对应彩种',
  自助返水详情: '自助返水详情',
  自助返水比例: '自助返水比例',
  历史返水记录: '历史返水记录',
  成长积分: '成长积分',
  尊贵的VIP: '尊贵的VIP',
  '会员，您可享受以上专属权益': '会员，您可享受以上专属权益',
  '充值大礼包已领取,一天只能领取一次!!!!': '充值大礼包已领取,一天只能领取一次!!!!',
  '最多投7注不同区域！': '最多投7注不同区域！',
  'activityRule1-1': '连续签到活动，中断后需从第一天开始继续签到，连续登陆签到礼品更丰富',
  'activityRule1-2': '活动时间内，每天一次签到机会',
  'activityRule1-3': 'VIP等级更高，每日所得彩金更丰富',
  'activityRule1-4': '为避免对文字的理解歧义，本平台保留对活动的最终解释权',
  '第{d}天': '第{d}天',
  自助返水: '自助返水',
  一键返水: '一键返水',
  '虚拟货币(线下)': '虚拟货币(线下)',
  数字人民币: '数字人民币',
  支付宝转银行卡教程: '支付宝转银行卡教程',
  微信转银行卡教程: '微信转银行卡教程',
  视频教程: '视频教程',
  支付宝转账教程: '支付宝转账教程',
  微信转账教程: '微信转账教程',
  次日1点结算: '次日1点结算',
  帮助教程: '帮助教程',
  充值成功: '充值成功',
  客户: '客户',
  成功到账: '成功到账',
  新回复: '新回复',
  站长: '站长',
  发送成功: '发送成功',
  输入回复消息: '输入回复消息',
  发送: '发送',
  内容不能为空: '内容不能为空',
  回复内容不能为空: '回复内容不能为空',
  请勿输入表情: '请勿输入表情',
  加载中: '加载中',
  拒绝原因: '拒绝原因',
  未绑定货币信息: '未绑定货币信息',
  '[提现金币]不能为空': '[提现金币]不能为空',
  快速充值: '快速充值',
  输入下级代理名称: '输入下级代理名称',
  我的团队报表: '我的团队报表',
  元: '金币',
  优惠金额: '优惠金额',
  团队返佣: '团队返佣',
  个人佣金: '个人佣金',
  佣金提现: '佣金提现',
  提现金额: '提现金额',
  首充人数: '首充人数',
  充值人数: '充值人数',
  注册人数: '注册人数',
  投注人数: '投注人数',
  名词解释: '名词解释',
  '该代理加所有下级已结算的有效注单(不包含和局)': '该代理加所有下级已结算的有效注单(不包含和局)',
  该代理加所有下级的中奖总额: '该代理加所有下级的中奖总额',
  该代理加所有下级的优惠金额总额: '该代理加所有下级的优惠金额总额',
  该代理加所有下级的返佣收益总额: '该代理加所有下级的返佣收益总额',
  该代理加所有下级的盈亏总额: '该代理加所有下级的盈亏总额',
  该代理从他的团队中获得的返佣收益: '该代理从他的团队中获得的返佣收益',
  该代理所有下级的各类游戏的输赢总额: '该代理所有下级的各类游戏的输赢总额',
  该代理加所有下级的充值总额: '该代理加所有下级的充值总额',
  该代理加所有下级的提现总: '该代理加所有下级的提现总',
  该代理加所有下级的总余额: '该代理加所有下级的总余额',
  该代理所有下级首次充值的人数: '该代理所有下级首次充值的人数',
  该代理所有下级注册用户数: '该代理所有下级注册用户数',
  该代理所有下级充值人数: '该代理所有下级充值人数',
  今天: '今天',
  本周: '本周',
  上周: '上周',
  下级人数共: '下级人数共',
  agencytext1: '团队盈亏计算公式：输赢+优惠金额+团队返佣',
  agencytext2: '以上是代理的团队数据（即他的所有下级的数据汇总）',
  充值总金币: '充值总金币',
  实际充值总金币: '实际充值总金币',
  提现总金币: '提现总金币',
  实际提现总金币: '实际提现总金币',
  汇总盈亏详情: '汇总盈亏详情',
  三色彩返点: '三色彩返点',
  佣金明细: '佣金明细',
  来自代理商自行开户: '来自代理商自行开户',
  会员名称: '会员名称',
  注册时间: '注册时间',
  代理商级别: '代理商级别',
  代理商描述: '代理商描述',
  状态时间: '状态时间',
  请输入昵称: '请输入昵称',
  来自注册: '来自注册',
  默认资金密码为注册时的登陆密码: '默认资金密码为注册时的登陆密码',
  请输入付款人姓名: '请输入付款人姓名',
  '[USDT地址]不能为空': '[USDT地址]不能为空',
  幸运注单: '幸运注单',
  钱包到余额宝: '钱包到余额宝',
  余额宝到钱包: '余额宝到钱包',
  充值大礼包: '充值大礼包',
  天天得意金: '天天得意金',
  领取亏损金额: '领取亏损金额',
  分享领工资: '分享领工资',
  '充值优惠-渠道优惠': '充值优惠-渠道优惠',
  晋级奖励: '晋级奖励',
  周俸禄: '周俸禄',
  月俸禄: '月俸禄',
  签到奖金: '签到奖金',
  虚拟币活动: '虚拟币活动',
  提现审核: '提现审核',
  提现拒绝: '提现拒绝',
  提现成功: '提现成功',
  购彩支付: '购彩支付',
  方案保底: '方案保底',
  购彩返还: '购彩返还',
  保底返还: '保底返还',
  追号返还: '追号返还',
  和局返还: '和局返还',
  和局追号返还: '和局追号返还',
  打码量扣减: '打码量扣减',
  购买套餐: '购买套餐',
  套餐返还: '套餐返还',
  发红包: '发红包',
  充值返还: '充值返还',
  'Phone number为11位数字，请重新输入': 'Phone number为11位数字，请重新输入',
  'CPF为11位数字，请重新输入': 'CPF为11位数字，请重新输入',
  'CNPJ为14位数字，请重新输入': 'CNPJ为14位数字，请重新输入',
  'Email不对，请重新输入': 'Email不对，请重新输入',
  洗码: '洗码',
  优惠活动: '优惠活动',
  crashDesc1: '什么是现金搏一搏？',
  crashDesc2: 'Cash or Crash 是一款令人兴奋的在线社交游戏。 这是一款简单而刺激的实时游戏，您可以安全地玩游戏，享受乐趣或赢得财富。',
  crashDesc3: '在每轮游戏中，您可以在该轮开始前下注。 此后，幸运乘数从 1 倍开始，并越来越高。',
  crashDesc4: '您在兑现之前在游戏中停留的时间越长，乘数就越高。 不过要小心！ 游戏随时可能爆发。 如果您在此之前没有退出，您就会输掉赌注。当然，游戏也可能会在刚开始就爆发。',
  crashDesc5: '如何下注并退出？',
  crashDesc6: '1. 按“投注”按钮进行投注。',
  crashDesc7: '2. 在回合结束前随时按“收集”按钮。',
  crashDesc8: '3. 但是，如果您没有在回合结束前退出，您将输掉赌注。',
  crashDesc9: '如何自动玩游戏并提现？',
  crashDesc10: '通过点击“自动”按钮，可以打开相关设置。 激活“自动”按钮进行投注后，您可以自动进行后续轮次的投注。',
  crashDesc11: '激活集合的“自动”按钮并输入所需的乘数。 当游戏达到输入的乘数时，您的赌注将被自动收集。',
  crashDesc12: '这个游戏公平吗？',
  crashDesc13: '每轮最终的乘数由“可能公平”算法生成，100%透明、公平。 Cash or Crash 可能是公平的，并且拥有市场上最低的庄家优势，仅为 1%。',
  crashDesc14: '游戏限制',
  crashDesc15: '最小赌注：1',
  crashDesc16: '最大赌注：1000',
  crashDesc17: '收集的最小乘数：1.2x',
  crashDesc18: '返还上限：100000',
  crashDesc19: '最大乘数：100000x',
  '选择一个数字，选择掷大于还是小于。': '选择一个数字，选择掷大于还是小于。',
  '选择投注金额。': '选择投注金额。',
  '点击投注，当开奖结果符合你的选择，你就中奖了。': '点击投注，当开奖结果符合你的选择，你就中奖了。',
  切换获胜条件: '切换获胜条件',
  降低目标: '降低目标',
  提高目标: '提高目标',
  掷大于: '掷大于',
  掷小于: '掷小于',
  获胜机率: '获胜机率',
  累计原创打码天数: '累计原创打码天数',
  哈希亏损: '哈希亏损',
  Crash爆点记录: 'Crash爆点记录',
  下一轮: '下一轮',
  正开始: '正开始',
  匿名: '匿名',
  投注次数不能为0: '投注次数不能为0',
  '手动投注进行中，不能自动投注': '手动投注进行中，不能自动投注',
  '必须先在“我的账户”绑定专用的TRC20钱包地址,再转账下注！': '必须先在“我的账户”绑定专用的TRC20钱包地址,再转账下注！',
  '您转账的虚拟货币的个位数为1，则代表压庄，其他代表压闲。举例：': '您转账的虚拟货币的个位数为1，则代表压庄，其他代表压闲。举例：',
  '转账1001 USDT，则代表您下注庄家赢。': '转账1001 USDT，则代表您下注庄家赢。',
  我的地址: '我的地址',
  钱包地址: '钱包地址',
  capitalText: '为了确保资金安全，每次使用均需要输入资金密码',
  收支明细: '收支明细',
  已隐藏: '已隐藏',
  钱包金币: '钱包金币',
  '确认转入吗？': '确认转入{num}吗？',
  '确认转出吗？': '确认转出{num}吗？',
  请绑定TRX地址: '请绑定TRX地址',
  请输入TRX钱包地址: '请输入TRX钱包地址',
  哈希游戏专用钱包地址: '哈希游戏专用钱包地址',
  请转账波场: '请转账波场',
  游戏规则: '游戏规则',
  仅接受: '仅接受',
  '向投注地址转账资金TRC20-USDT': '向投注地址转账资金TRC20-USDT',
  '转账低于最小额度视为无效投注，不进行返奖': '转账低于最小额度视为无效投注，不进行返奖',
  '转账大于最大额度扣除{num}手续费，退还本金': '转账大于最大额度扣除{num}手续费，退还本金',
  您转账的区块哈希最后1个数字作为开奖的依据: '您转账的区块哈希最后1个数字作为开奖的依据',
  '0、1、2、3、4表示小': '0、1、2、3、4表示小',
  '5、6、7、8、9表示大': '5、6、7、8、9表示大',
  '1、3、5、7、9表示单': '1、3、5、7、9表示单',
  '0、2、4、6、8表示双': '0、2、4、6、8表示双',
  '您转账的虚拟货币数量的个位数字作为押注的类型，举例': '您转账的虚拟货币数量的个位数字作为押注的类型，举例',
  '1000表示小': '1000表示小',
  '1009表示大': '1009表示大',
  '1001表示单': '1001表示单',
  '1008表示双': '1008表示双',
  注意: '注意',
  您转账的区块哈希最后2位作为开奖的依据: '您转账的区块哈希最后2位作为开奖的依据',
  '若是1个数字和1个字母，则表示您赢；若是2个数字或者2个字母，则表示您输。': '若是1个数字和1个字母，则表示您赢；若是2个数字或者2个字母，则表示您输。',
  '庄家取倒数4、5位，闲家取倒数1、2位': '庄家取倒数4、5位，闲家取倒数1、2位',
  '字母=0，将2个字符相加取和值尾数，9最大，0最小。': '字母=0，将2个字符相加取和值尾数，9最大，0最小。',
  '1001表示押庄': '1001表示押庄',
  其他表示押闲: '其他表示押闲',
  '您转账的区块哈希末尾5位，如：（00000……537b3）作为开奖的依据': '您转账的区块哈希末尾5位，如：（00000……537b3）作为开奖的依据',
  '庄家取倒数3、4、5位，闲家取倒数1、2、3位': '庄家取倒数3、4、5位，闲家取倒数1、2、3位',
  '字母=10，3个字符中，有1个是字母，则表示有牛（3个都是数字则表示无牛），另2个相加和尾为牛的点数。': '字母=10，3个字符中，有1个是字母，则表示有牛（3个都是数字则表示无牛），另2个相加和尾为牛的点数。',
  '最大牌为3个字母，翻5倍；牛牛（1个字母+另2个相加和尾为0）翻3倍；牛7~9（1个字母+2个相加和尾为7、8、9）翻2倍；其他翻1倍。': '最大牌为3个字母，翻5倍；牛牛（1个字母+另2个相加和尾为0）翻3倍；牛7~9（1个字母+2个相加和尾为7、8、9）翻2倍；其他翻1倍。',
  '同点比最大1个字符，从大到小依次为fedcba9876543210，依然同点，则比第二大字符，依然同点，则比第三大字符，依然同点，扣除{num}手续费退还本金。': '同点比最大1个字符，从大到小依次为fedcba9876543210，依然同点，则比第二大字符，依然同点，则比第三大字符，依然同点，扣除{num}手续费退还本金。',
  '转账的个位数为1，则代表压庄，其他代表压闲。': '转账的个位数为1，则代表压庄，其他代表压闲。',
  '举例：转账100.85USDT,则表示您下注闲家赢。': '举例：转账100.85USDT,则表示您下注闲家赢。',
  投注金额是转账金额的五分之一: '投注金额是转账金额的五分之一',
  '如押注10USDT，则需要转账50USDT': '如押注10USDT，则需要转账50USDT',
  幸运哈希: '幸运哈希',
  立即游戏: '立即游戏',
  哈希PK10: '哈希PK10',
  起投: '起投',
  哈希庄闲: '哈希庄闲',
  幸运数字: '幸运数字',
  平倍牛牛: '平倍牛牛',
  '[钱包地址]不满足格式要求': '[钱包地址]不满足格式要求',
  '[钱包地址]被注册过': '[钱包地址]被注册过',
  该钱包地址已经被绑定过了: '该钱包地址已经被绑定过了',
  五倍牛牛: '五倍牛牛',
  投注地址: '投注地址',
  哈希代码: '哈希代码',
  '转账不在额度范围扣除{num} (不低于1USDT)手续费，退还本金': '转账不在额度范围扣除{num} (不低于1USDT)手续费，退还本金',
  您转账的区块哈希最后5位作为开奖的依据: '您转账的区块哈希最后5位作为开奖的依据',
  '最大牌为3个字母，其他依次为牛牛、牛9~1(1个字母+另2个相加和尾为0~9),无牛(3个数字)': '最大牌为3个字母，其他依次为牛牛、牛9~1(1个字母+另2个相加和尾为0~9),无牛(3个数字)',
  退回金额低于1USDT不予退回: '退回金额低于1USDT不予退回',
  扣除手续费后金额低于1USD不予退回: '扣除手续费后金额低于1USD不予退回',
  '同点比最大1个字符，从大到小依次为fedcba9876543210，依然同点，则比第二大字符，依然同点，扣除手续费退还本金。': '同点比最大1个字符，从大到小依次为fedcba9876543210，依然同点，则比第二大字符，依然同点，扣除手续费退还本金。',
  '选择一个颜色，选择你想要下注的金额，摁下投注按钮。': '选择一个颜色，选择你想要下注的金额，摁下投注按钮。',
  '您选择的颜色，与游戏停止时选中的颜色一致，恭喜您中奖了，黑色和红色是2倍的赔率，白色是14倍的赔率。': '您选择的颜色，与游戏停止时选中的颜色一致，恭喜您中奖了，黑色和红色是2倍的赔率，白色是14倍的赔率。',
  最小额度: '最小额度',
  最大额度: '最大额度',
  历史开奖: '历史开奖',
  选择颜色: '选择颜色',
  最小: '最小',
  最大投注额: '最大投注额',
  请选择颜色: '请选择颜色',
  '自动投注进行中，不能手动投注': '自动投注进行中，不能手动投注',
  随机翻开瓷砖: '随机翻开瓷砖',
  '每翻开一颗宝石就能增加支付乘数。': '每翻开一颗宝石就能增加支付乘数。',
  '您可以随时兑现当前乘数的奖金。': '您可以随时兑现当前乘数的奖金。',
  '一旦翻开地雷，您将输掉赌注，游戏也就此结束。': '一旦翻开地雷，您将输掉赌注，游戏也就此结束。',
  '增加配置的地雷数量将会直接提高翻牌乘数。': '增加配置的地雷数量将会直接提高翻牌乘数。',
  往期结果: '往期结果',
  炸弹数量: '炸弹数量',
  字节到数字: '字节到数字',
  '第{key}组': '第{key}组',
  数字到洗牌: '数字到洗牌',
  重新开始: '重新开始',
  下单购彩: '下单购彩',
  转账充值: '转账充值',
  中奖自动提现: '中奖自动提现',
  中奖派送: '中奖派送',
  哈希: '哈希',
  '已派发到您的账号 请查收': '已派发到您的账号 请查收',
  我的当前积分: '我的当前积分',
  明日转化积分: '明日转化积分',
  开始: '开始',
  抽奖: '抽奖',
  每次消耗: '每次消耗',
  积分: '积分',
  恭喜您获得奖励金额: '恭喜您获得奖励金额',
  系统已自动发放至您的账户内: '系统已自动发放至您的账户内',
  请注意查收: '请注意查收',
  查看奖励: '查看奖励',
  继续抽奖: '继续抽奖',
  '谢谢惠顾，再接再厉': '谢谢惠顾，再接再厉',
  谢谢惠顾: '谢谢惠顾',
  上一期: '上一期',
  封盘: '封盘',
  开盘中: '开盘中',
  封盘中: '封盘中',
  尾号: '尾号',
  反投: '反投',
  正投: '正投',
  购买记录: '购买记录',
  绘图记录: '绘图记录',
  结果: '结果',
  交易: '交易',
  印度彩: '印度彩',
  印度三色彩: '印度三色彩',
  可用余额: '可用余额',
  规则: '规则',
  开奖倒计时: '开奖倒计时',
  颜色: '颜色',
  紫色: '紫色',
  绿色: '绿色',
  红色: '红色',
  玩法规则: '玩法规则',
};

const help = {
  在线客服: '在线客服',
  QQ客服: 'QQ客服',
  微信客服: '微信客服',
  Telegram: 'Telegram',
  Whatsapp: 'Whatsapp',
  Facebook: 'Facebook',
  Zalo: 'Zalo',
  客服电话: '客服电话',
  账号交易: '账号交易',
  常见问题: '常见问题',
  客服类型: '客服类型',
  联系方式: '联系方式',
  操作: '操作',
  代理QQ: '代理QQ',
  QQ联系: 'QQ联系',
  微信联系: '微信联系',
  联系: '联系',
  电话联系: '电话联系',
  可借额度: '可借额度',
  待还额度: '待还额度',
  '随借随还 | 信用=金钱': '随借随还 | 信用=金钱',
  '本平台多样化的优惠活动，同时我们也在研究如何解决客户因资金短缺而无法脱离游戏的问题，逐步促进娱乐体验和方便客户，信用管家应此而生。': '本平台多样化的优惠活动，同时我们也在研究如何解决客户因资金短缺而无法脱离游戏的问题，逐步促进娱乐体验和方便客户，信用管家应此而生。',
  '信用管家是由本平台推出的一种个人游戏的替代服务，可以满足您对资金的需求。': '信用管家是由本平台推出的一种个人游戏的替代服务，可以满足您对资金的需求。',
  我的借款: '我的借款',
  '借款时，您可以放款到账户余额中，使用信用金进行投注、提现。': '借款时，您可以放款到账户余额中，使用信用金进行投注、提现。',
  '借款可以免费使用一个月，随借随还，不产生利息。': '借款可以免费使用一个月，随借随还，不产生利息。',
  我的还款: '我的还款',
  '还款时，确保账户余额的可提现资金足够还款。': '还款时，确保账户余额的可提现资金足够还款。',
  逾期还款: '逾期还款',
  '如果产生逾期，将不再享有部分优惠活动，不赠送游戏彩金。': '如果产生逾期，将不再享有部分优惠活动，不赠送游戏彩金。',
  '如果多次或长时间逾期未还款，将关闭信用管家的使用权限；故意拖欠且情节严重的，会导致游戏账户被冻结。': '如果多次或长时间逾期未还款，将关闭信用管家的使用权限；故意拖欠且情节严重的，会导致游戏账户被冻结。',
  '全新升级模式，账户等级越高，等级礼金越高，周俸禄越高，月俸禄越高，对应的可申请信用额度也就越高。': '全新升级模式，账户等级越高，等级礼金越高，周俸禄越高，月俸禄越高，对应的可申请信用额度也就越高。',
  我要借款: '我要借款',
  '根据当前账号情况，可借额度': '根据当前账号情况，可借额度',
  当前礼金: '当前礼金',
  '1、申请前请完善个人资料，方便联系通过审核；': '1、申请前请完善个人资料，方便联系通过审核；',
  '2、请用户根据自身的需求填写申请额度，当有欠款时，请先还清欠款再来借款。': '2、请用户根据自身的需求填写申请额度，当有欠款时，请先还清欠款再来借款。',
  '根据当前账号情况，欠款金币': '根据当前账号情况，欠款金币',
  我要还款: '我要还款',
  当前余额: '当前余额',
  '2、确保账户余额的可提现资金足够还款。': '2、确保账户余额的可提现资金足够还款。',
  '创建人:自己': '创建人:自己',
  利润率追号: '利润率追号',
  同倍追号: '同倍追号',
  翻倍追号: '翻倍追号',
  连购期数: '连购期数',
  起始倍数: '起始倍数',
  最低收益率: '最低收益率',
  生成追号计划: '生成追号计划',
  开奖期号: '开奖期号',
  中奖后停止追号: '中奖后停止追号',
  追号投注: '追号投注',
  立即签到: '立即签到',
  '相同IP参与签到次数过多!': '相同IP参与签到次数过多!',
  '活动时间内充值/打码量不足{num}，不能参与该活动': '活动时间内充值/打码量不足{num}，不能参与该活动',
  '每日打码量未达到{num}，签到失败': '每日打码量未达到{num}，签到失败',
  '每日充值未达到{num}，签到失败': '每日充值未达到{num}，签到失败',
  签到失败: '签到失败',
  签到奖励: '签到奖励',
  已派发到您的钱包请查收: '已派发到您的钱包请查收',
  活动规则: '活动规则',
  '1、连续签到活动，中断后需从第一天开始继续签到，连续登陆签到礼品更丰富': '1、连续签到活动，中断后需从第一天开始继续签到，连续登陆签到礼品更丰富',
  '2、活动时间内，每天一次签到机会': '2、活动时间内，每天一次签到机会',
  '3、VIP等级更高，每日所得彩金更丰富': '3、VIP等级更高，每日所得彩金更丰富',
  '4、为避免对文字的理解歧义,本平台保留对活动的最终解释权': '4、为避免对文字的理解歧义,本平台保留对活动的最终解释权',
  活动任务: '活动任务',
  审核进度: '审核进度',
  敬请期待: '敬请期待',
  禁用列表: '禁用列表',
  '图片无法显示，请检查路径是否正确': '图片无法显示，请检查路径是否正确',
  请输入验证码: '请输入验证码',
  提交申请: '提交申请',
  任务中心: '任务中心',
  每日完成任务: '每日完成任务',
  丰厚奖品: '丰厚奖品',
  每日任务: '每日任务',
  即将开始: '即将开始',
  可领取: '可领取',
  今日24点结算: '今日24点结算',
  分享领工资: '分享领工资',
  '项，可领取': '项，可领取',
  一键领取: '一键领取',
  '暂无数据！': '暂无数据！',
  优惠申请进度查询: '优惠申请进度查询',
  请选择查询项目: '请选择查询项目',
  点击查询: '点击查询',
  优惠申请进度查询详情: '优惠申请进度查询详情',
  会员账号: '会员账号',
  申请时间: '申请时间',
  申请状态: '申请状态',
  暂无记录: '暂无记录',
  加载更多: '加载更多',
  回复内容: '回复内容',
  暂无内容: '暂无内容',
  任务详情: '任务详情',
  '任务简介：': '任务简介：',
  '任务有效时间：': '任务有效时间：',
  '任务范围：': '任务范围：',
  '任务说明：': '任务说明：',
  '所属平台：': '所属平台：',
  '记录VIP进度：': '记录VIP进度：',
  账号价值: '账号价值',
  交易记录: '交易记录',
  评估价格: '评估价格',
  交易帮助: '交易帮助',
  '根据当前账号情况，账号价值：': '根据当前账号情况，账号价值：',
  当前等级: '当前等级',
  等级礼金: '等级礼金',
  '(申请价格与账号价值波动越小，审核成功率越高)': '(申请价格与账号价值波动越小，审核成功率越高)',
  请输入金币: '请输入金币',
  '2.申请交易必须先联系专属客服：': '2.申请交易必须先联系专属客服：',
  '账号状态：': '账号状态：',
  账号将在: '账号将在',
  '超过保留期，届时将被锁定，请在保留期钱提前处理钱包余额。': '超过保留期，届时将被锁定，请在保留期钱提前处理钱包余额。',
  '申请交易必须提前联系专属客服：': '申请交易必须提前联系专属客服：',
  系统回收: '系统回收',
  账号评估: '账号评估',
  我要赎回: '我要赎回',
  交易时间: '交易时间',
  交易类型: '交易类型',
  交易价格: '交易价格',
  系统赎回: '系统赎回',
  VIP等级: 'VIP等级',
  '如何购买账号?': '如何购买账号?',
  '点击【我要买】或点击出售大厅、热卖账号栏目内右边的【立即购买】按钮，联系【账号交易专员】，提供报价和相关信息要求(如您的最高报价)，专员将即刻为您联系卖方进行购买事宜。': '点击【我要买】或点击出售大厅、热卖账号栏目内右边的【立即购买】按钮，联系【账号交易专员】，提供报价和相关信息要求(如您的最高报价)，专员将即刻为您联系卖方进行购买事宜。',
  '如何出售账号?': '如何出售账号?',
  '点击【我要卖】，添加【账号交易专员】，填写交易价格，系统审核通过后，即可出现在出售大厅栏目上，若有买方想购买，专员将及时联系卖方。': '点击【我要卖】，添加【账号交易专员】，填写交易价格，系统审核通过后，即可出现在出售大厅栏目上，若有买方想购买，专员将及时联系卖方。',
  '如何查看账号价值?': '如何查看账号价值?',
  '账号价值是根据会员账号的会员账号、账号等级、晋级礼金、周俸禄、月俸禄，以及账号是否为靓号(如：wcw168，woaini1314，love1314)等进行评估，可点击【评估价格】，填写相关信息，系统将给您一个参考价格，您可根据系统给的参考价格进行加价或者减价，卖方买方亦可进行一定的加价和砍价。': '账号价值是根据会员账号的会员账号、账号等级、晋级礼金、周俸禄、月俸禄，以及账号是否为靓号(如：wcw168，woaini1314，love1314)等进行评估，可点击【评估价格】，填写相关信息，系统将给您一个参考价格，您可根据系统给的参考价格进行加价或者减价，卖方买方亦可进行一定的加价和砍价。',
  '如何保证资金安全?': '如何保证资金安全?',
  '交易过程资金由平台全程担保，不收取任何手续费。': '交易过程资金由平台全程担保，不收取任何手续费。',
  '买方跟卖方达成双方满意的价格后，账号交易专员将联系买方和卖方进行信息核实': '买方跟卖方达成双方满意的价格后，账号交易专员将联系买方和卖方进行信息核实',
  '2.买方将谈好的金币，打入账号交易专员指定的账号，并提供新账号所绑定的真实姓名和银行卡号，专员将进行信息录入。': '2.买方将谈好的金币，打入账号交易专员指定的账号，并提供新账号所绑定的真实姓名和银行卡号，专员将进行信息录入。',
  '3.卖方提供会员账号的登入信息，专员记录相关信息，将会员账号进行初始化。': '3.卖方提供会员账号的登入信息，专员记录相关信息，将会员账号进行初始化。',
  '4.买方确认信息真实确切无误后，账号交易专员将款项打入卖方所出售的会员账号原绑定的银行卡号，交易完成。': '4.买方确认信息真实确切无误后，账号交易专员将款项打入卖方所出售的会员账号原绑定的银行卡号，交易完成。',
  '如何保证交易安全?': '如何保证交易安全?',
  '1.交易过程资金由平台全程担保，不收取任何手续费。': '1.交易过程资金由平台全程担保，不收取任何手续费。',
  '2.当交易完成，账号的信息变更成功后，交易记录全程录入，卖方无法通过任何方式取回账号，买方务必第一时间进行信息核实并且更改登入密码、取款密码等相关信息，并妥善保管。': '2.当交易完成，账号的信息变更成功后，交易记录全程录入，卖方无法通过任何方式取回账号，买方务必第一时间进行信息核实并且更改登入密码、取款密码等相关信息，并妥善保管。',
  '如何账号系统回收?': '如何账号系统回收?',
  '若您的账号不想进行游戏，只需填写账号相关信息，提交系统回收申请，确实为本人自愿提交申请后，将以系统估值，进行账号回收。系统回收后，玩家仍可正常充值提现投注，需在保留期内及时赎回，保留期将被锁定，需联系客服处理！': '若您的账号不想进行游戏，只需填写账号相关信息，提交系统回收申请，确实为本人自愿提交申请后，将以系统估值，进行账号回收。系统回收后，玩家仍可正常充值提现投注，需在保留期内及时赎回，保留期将被锁定，需联系客服处理！',
  点击加载更多: '点击加载更多',
  请输入正确的金额: '请输入正确的金额',
  '当前价格比评估最低价，还低': '当前价格比评估最低价，还低',
  ',请重新填写': ',请重新填写',
  '当前价格比评估最高价，还高': '当前价格比评估最高价，还高',
  请勿重复点击: '请勿重复点击',
  晋级模式: '晋级模式',
  等级特权: '等级特权',
  累计晋级奖励: '累计晋级奖励',
  存款加速通道: '存款加速通道',
  专属客服经理: '专属客服经理',
  方案详情: '方案详情',
  请输入正确的投注金币: '请输入正确的投注金币',
  请输入正确的投注方案期数: '请输入正确的投注方案期数',
  请输入正确的投注方案倍数: '请输入正确的投注方案倍数',
  '确认投注吗？': '确认投注吗？',
  '确认取消自动投注吗？': '确认取消自动投注吗？',
  取消成功: '取消成功',
  取消失败: '取消失败',
  我的回水: '我的回水',
  '自动回水，客服审核(满足条件)': '自动回水，客服审核(满足条件)',
  回水规则: '回水规则',
  房间等级: '房间等级',
  '暂无回水记录！': '暂无回水记录！',
  初级房回水比例说明: '初级房回水比例说明',
  '亏损（当天）': '亏损（当天）',
  回水比例: '回水比例',
  中级房回水比例说明: '中级房回水比例说明',
  高级房回水比例说明: '高级房回水比例说明',
  回水条件: '回水条件',
  '1、同一房间等级当天下注满10期；': '1、同一房间等级当天下注满10期；',
  '2、组合比例不低于当天投注金币的20%；': '2、组合比例不低于当天投注金币的20%；',
  '3、严禁刷水，发现一律无回水。': '3、严禁刷水，发现一律无回水。',
  '4、回水到账后，请移至账户明细查询。': '4、回水到账后，请移至账户明细查询。',
  '5、符合条件，平台于0点~6点之间审核结算至您的账户，不支持提前结算。': '5、符合条件，平台于0点~6点之间审核结算至您的账户，不支持提前结算。',
  '3万以下': '3万以下',
  '3-20万': '3-20万',
  '20-100万': '20-100万',
  '100-500万': '100-500万',
  '500万以上': '500万以上',
  '返点介绍：': '返点介绍：',
  返佣比例表: '返佣比例表',
  '1、每一级返点是该级玩家流水*对应级别的返佣比例。二级开始需要乘以对应的递减系数，您的总返点为所有级别下线贡献返点之和，不限级别。': '1、每一级返点是该级玩家流水*对应级别的返佣比例。二级开始需要乘以对应的递减系数，您的总返点为所有级别下线贡献返点之和，不限级别。',
  '2、返佣比例根据您的直属下级总流水确定，直属流水越高对应的返佣比例越高。': '2、返佣比例根据您的直属下级总流水确定，直属流水越高对应的返佣比例越高。',
  '3、返点是每日统计，次日派发。': '3、返点是每日统计，次日派发。',
  '计算说明：': '计算说明：',
  '1、假设您的直属流水总额3万以下，那么您的返佣比例为1.90%，返佣递减系数为30%。': '1、假设您的直属流水总额3万以下，那么您的返佣比例为1.90%，返佣递减系数为30%。',
  '2、您的返点=1级返点+2级返点+...+N级返点': '2、您的返点=1级返点+2级返点+...+N级返点',
  '1级返点=所有B的流水*1.90%': '1级返点=所有B的流水*1.90%',
  '2级返点=所有C的流水*1.90%*30.00%': '2级返点=所有C的流水*1.90%*30.00%',
  'N级返点=所有N的流水*1.90%*30.00%^(N-1)': 'N级返点=所有N的流水*1.90%*30.00%^(N-1)',
  '返点计算实例：': '返点计算实例：',
  '开奖结果为五码 (万、仟、佰、拾、个)。假设结果为1 、2 、3 、4、5。': '开奖结果为五码 (万、仟、佰、拾、个)。假设结果为1 、2 、3 、4、5。',
  '例1：A的直属玩家B1、B2、B3历史总流水分别为20万、30万、35万，B1、B2、B3当天流水为60000、80000、100000，B没有发展用户，那么A今天能赚多少佣金呢？': '例1：A的直属玩家B1、B2、B3历史总流水分别为20万、30万、35万，B1、B2、B3当天流水为60000、80000、100000，B没有发展用户，那么A今天能赚多少佣金呢？',
  '（60000+80000+100000）*2.10%=5040': '（60000+80000+100000）*2.10%=5040',
  '例2：A的直属玩家B1、B2、B3、B4历史总流水分别为20万、30万、35万、20万，B1、B2、B3、B4当天流水为60000、80000、100000、60000，B发展的用户C1、C2、C3当天流水为40000、80000、40000。C没有发展用户，那么A今天能赚多少佣金呢？': '例2：A的直属玩家B1、B2、B3、B4历史总流水分别为20万、30万、35万、20万，B1、B2、B3、B4当天流水为60000、80000、100000、60000，B发展的用户C1、C2、C3当天流水为40000、80000、40000。C没有发展用户，那么A今天能赚多少佣金呢？',
  '（60000+80000+100000+60000）*2.20%+（40000+80000+40000）*2.20%*36%=7867.2': '（60000+80000+100000+60000）*2.20%+（40000+80000+40000）*2.20%*36%=7867.2',
  '1、每一级返点是该级玩家正盈利注单盈利总额*对应级别的返佣比例。二级开始需要乘以对应的递减系数，您的总返点为所有级别下线贡献返点之和，不限级别。': '1、每一级返点是该级玩家正盈利注单盈利总额*对应级别的返佣比例。二级开始需要乘以对应的递减系数，您的总返点为所有级别下线贡献返点之和，不限级别。',
  '1级返点=所有B的正盈利注单盈利总额*1.90%': '1级返点=所有B的正盈利注单盈利总额*1.90%',
  '2级返点=所有C的正盈利注单盈利总额*1.90%*30.00%': '2级返点=所有C的正盈利注单盈利总额*1.90%*30.00%',
  'N级返点=所有N的正盈利注单盈利总额*1.90%*30.00%^(N-1)': 'N级返点=所有N的正盈利注单盈利总额*1.90%*30.00%^(N-1)',
  '例1：A的直属玩家B1、B2、B3历史总流水分别为20万、30万、35万，B1、B2、B3当天盈利注单盈利总额为30000、40000、50000，B没有发展用户，那么A今天能赚多少佣金呢？': '例1：A的直属玩家B1、B2、B3历史总流水分别为20万、30万、35万，B1、B2、B3当天盈利注单盈利总额为30000、40000、50000，B没有发展用户，那么A今天能赚多少佣金呢？',
  '（30000+40000+50000）*2.10%=2520': '（30000+40000+50000）*2.10%=2520',
  '例2：A的直属玩家B1、B2、B3、B4历史总流水分别为20万、30万、35万、20万，B1、B2、B3、B4当天盈利注单盈利总额为30000、40000、50000、30000，B发展的用户C1、C2、C3当天盈利注单盈利总额为20000、40000、20000。C没有发展用户，那么A今天能赚多少佣金呢？': '例2：A的直属玩家B1、B2、B3、B4历史总流水分别为20万、30万、35万、20万，B1、B2、B3、B4当天盈利注单盈利总额为30000、40000、50000、30000，B发展的用户C1、C2、C3当天盈利注单盈利总额为20000、40000、20000。C没有发展用户，那么A今天能赚多少佣金呢？',
  '（30000+40000+50000+30000）*2.20%+（20000+40000+20000）*2.20%*36%=3933.6': '（30000+40000+50000+30000）*2.20%+（20000+40000+20000）*2.20%*36%=3933.6',
  '1、每一级返点是该级玩家负盈利注单盈利总额绝对值*对应级别的返佣比例。二级开始需要乘以对应的递减系数，您的总返点为所有级别下线贡献返点之和，不限级别。': '1、每一级返点是该级玩家负盈利注单盈利总额绝对值*对应级别的返佣比例。二级开始需要乘以对应的递减系数，您的总返点为所有级别下线贡献返点之和，不限级别。',
  '1、假设您的直属流水总额3万以下，那么您的返佣比例为1.50%，返佣递减系数为30%。': '1、假设您的直属流水总额3万以下，那么您的返佣比例为1.50%，返佣递减系数为30%。',
  '1级返点=所有B的负盈利注单盈利总额绝对值*1.90%': '1级返点=所有B的负盈利注单盈利总额绝对值*1.90%',
  '2级返点=所有C的负盈利注单盈利总额绝对值*1.90%*30.00%': '2级返点=所有C的负盈利注单盈利总额绝对值*1.90%*30.00%',
  'N级返点=所有N的负盈利注单盈利总额绝对值*1.90%*30.00%^(N-1)': 'N级返点=所有N的负盈利注单盈利总额绝对值*1.90%*30.00%^(N-1)',
  '例1：A的直属玩家B1、B2、B3历史总流水分别为20万、30万、35万，B1、B2、B3当天负盈利注单盈利总额为-30000、-40000、-50000，B没有发展用户，那么A今天能赚多少佣金呢？':
    '例1：A的直属玩家B1、B2、B3历史总流水分别为20万、30万、35万，B1、B2、B3当天负盈利注单盈利总额为-30000、-40000、-50000，B没有发展用户，那么A今天能赚多少佣金呢？',
  '例2：A的直属玩家B1、B2、B3、B4历史总流水分别为20万、30万、35万、20万，B1、B2、B3、B4当天负盈利注单盈利总额为-30000、-40000、-50000、-30000，B发展的用户C1、C2、C3当天负盈利注单盈利总额为-20000、-40000、-20000。C没有发展用户，那么A今天能赚多少佣金呢？':
    '例2：A的直属玩家B1、B2、B3、B4历史总流水分别为20万、30万、35万、20万，B1、B2、B3、B4当天负盈利注单盈利总额为-30000、-40000、-50000、-30000，B发展的用户C1、C2、C3当天负盈利注单盈利总额为-20000、-40000、-20000。C没有发展用户，那么A今天能赚多少佣金呢？',
  '1、假如你是': '1、假如你是',
  ',你邀请了': ',你邀请了',
  '，B又邀请了': '，B又邀请了',
  '，A无投注，B,C,D,E,F各投注': '，A无投注，B,C,D,E,F各投注',
  '10万': '10万',
  和: '和',
  '。即A的总流水为': '。即A的总流水为',
  '50万': '50万',
  '，第': '，第',
  '级，每万': '级，每万',
  '80金币': '80金币',
  返佣: '返佣',
  自营佣金: '自营佣金',
  'B,C,D三人位A的': 'B,C,D三人位A的',
  直推下级: '直推下级',
  '，B,C,D总计投注': '，B,C,D总计投注',
  '30万': '30万',
  '，作为A的': '，作为A的',
  自营流水: '自营流水',
  '，按每万80金币返佣': '，按每万80金币返佣',
  A的自营佣金: 'A的自营佣金',
  '=A自营流水*A返佣比例=30*80=2400': '=A自营流水*A返佣比例=30*80=2400',
  '3、级差佣金': '3、级差佣金',
  'B邀请了E和F,E和F投注的': 'B邀请了E和F,E和F投注的',
  '20万': '20万',
  '，作为B的团队流水': '，作为B的团队流水',
  '，A可以从B的团队流水获得级差佣金': '，A可以从B的团队流水获得级差佣金',
  A的级差佣金: 'A的级差佣金',
  '=（A返佣比例-B返佣比例）*B团队流水=(80-60)*20=400': '=（A返佣比例-B返佣比例）*B团队流水=(80-60)*20=400',
  返佣对照示例表: '返佣对照示例表',
  级别: '级别',
  流水区间: '流水区间',
  '1级': '1级',
  '每万/30金币': '每万/30金币',
  '2级': '2级',
  '0.5万+': '0.5万+',
  '每万/35金币': '每万/35金币',
  '3级': '3级',
  '1万+': '1万+',
  '每万/40金币': '每万/40金币',
  '4级': '4级',
  '5万+': '5万+',
  '每万/50金币': '每万/50金币',
  '5级': '5级',
  '20万+': '20万+',
  '每万/60金币': '每万/60金币',
  '6级': '6级',
  '40万+': '40万+',
  '每万/80金币': '每万/80金币',
  '7级': '7级',
  '100万+': '100万+',
  '每万/100金币': '每万/100金币',
  '8级': '8级',
  '200万+': '200万+',
  '每万/110金币': '每万/110金币',
  '9级': '9级',
  '500万+': '500万+',
  '每万/120金币': '每万/120金币',
  '10级': '10级',
  '1000万+': '1000万+',
  '每万/150金币': '每万/150金币',
  返佣金币表: '返佣金币表',
  '1、每月的佣金总额达到一定量时可获得丰富的激励佣金': '1、每月的佣金总额达到一定量时可获得丰富的激励佣金',
  '2、想要享受更高返佣，请咨询客服升级代理方案。': '2、想要享受更高返佣，请咨询客服升级代理方案。',
  '(联系在线客服申请)': '(联系在线客服申请)',
  '★方案一：（佣金）时时结算，抽水代理方案': '★方案一：（佣金）时时结算，抽水代理方案',
  代理优惠: '代理优惠',
  比例: '比例',
  佣金派送形式: '佣金派送形式',
  下级会员存款总额: '下级会员存款总额',
  '24小时，时时进行统计和派送佣金。': '24小时，时时进行统计和派送佣金。',
  '【时时结算】完成会自动把额度添加到您的会员账户里面，您可以直接取款或者放在会员账户里面继续娱乐赚钱。': '【时时结算】完成会自动把额度添加到您的会员账户里面，您可以直接取款或者放在会员账户里面继续娱乐赚钱。',
  下级会员有效投注额: '下级会员有效投注额',
  '1、充值金返佣': '1、充值金返佣',
  '当天代理线下直属会员总存款200000x5‰=1000': '当天代理线下直属会员总存款200000x5‰=1000',
  '当天代理线下直属会员总存款400000x5‰=2000': '当天代理线下直属会员总存款400000x5‰=2000',
  '当天代理线下直属会员总存款1000000x5‰=5000': '当天代理线下直属会员总存款1000000x5‰=5000',
  '2、投注金返佣': '2、投注金返佣',
  '代理优势：无任何门槛，拥有无限线下代理，线下投注即可分佣，月收入轻松超万不再是梦。': '代理优势：无任何门槛，拥有无限线下代理，线下投注即可分佣，月收入轻松超万不再是梦。',
  '当天代理线下直属会员打码量（500000x1‰=500）=500': '当天代理线下直属会员打码量（500000x1‰=500）=500',
  '当天代理线下直属打码量（1000000x1‰=1000）=1000': '当天代理线下直属打码量（1000000x1‰=1000）=1000',
  '当天代理线下直属打码量（3000000x1‰=3000）=3000': '当天代理线下直属打码量（3000000x1‰=3000）=3000',
  '★方案二：（佣金）周结算，实际代理盈利方案': '★方案二：（佣金）周结算，实际代理盈利方案',
  当周负盈利: '当周负盈利',
  有效会员: '有效会员',
  退佣比例: '退佣比例',
  '2个会员或以上': '2个会员或以上',
  '3个会员或以上': '3个会员或以上',
  '5个会员或以上': '5个会员或以上',
  '10个会员或以上': '10个会员或以上',
  '15个会员或以上': '15个会员或以上',
  '800000以上': '800000以上',
  '20个会员或以上': '20个会员或以上',
  '例如：': '例如：',
  'A：代理线下直属会员拥有5个有效会员星期一到星期日存取款总累计的负盈利58000金币（扣除相应费用后），依照上表门槛x佣金百分比，那么代理可得佣金58000金币x15%=8700金币。': 'A：代理线下直属会员拥有5个有效会员星期一到星期日存取款总累计的负盈利58000金币（扣除相应费用后），依照上表门槛x佣金百分比，那么代理可得佣金58000金币x15%=8700金币。',
  'B：代理下线客户拥有18个有效会员（未达到20个有效会员）星期一到星期日存取款总累计的负盈利58万金币（扣除相应费用后），依照上表门槛x佣金百分比，那么代理可得佣金58万x25%=145000金币。': 'B：代理下线客户拥有18个有效会员（未达到20个有效会员）星期一到星期日存取款总累计的负盈利58万金币（扣除相应费用后），依照上表门槛x佣金百分比，那么代理可得佣金58万x25%=145000金币。',
  '代理A所有直属下级当天累计存款10万，存款返佣比例{ck}，直属下级当天累计棋牌有效投注额10万，彩票有效投注额10万，而棋牌和彩票返佣比例分别为{qp}和{cp}': '代理A所有直属下级当天累计存款10万，存款返佣比例{ck}%，直属下级当天累计棋牌有效投注额10万，彩票有效投注额10万，而棋牌和彩票返佣比例分别为{qp}%和{cp}%',
  '则代理A当天佣金=10万*{ck}%+10万*{qp}%+10万*{cp}%={ckt}+{qpt}+{cpt}={total}。该返佣为实时发放。': '则代理A当天佣金=10万*{ck}%+10万*{qp}%+10万*{cp}%={ckt}+{qpt}+{cpt}={total}。该返佣为实时发放。',
  '周负盈利抽成：代理B适用如下方案：': '周负盈利抽成：代理B适用如下方案：',
  本周负盈利: '本周负盈利',
  '代理B本周所有直属下级共有18名有效会员，且本周累计负盈利为50万，有效会员和周负盈利处在同一个返佣比例考核区间即25%内，则下周一凌晨结算代理佣金时B可获得50万*25%=12.5万佣金。': '代理B本周所有直属下级共有18名有效会员，且本周累计负盈利为50万，有效会员和周负盈利处在同一个返佣比例考核区间即25%内，则下周一凌晨结算代理佣金时B可获得50万*25%=12.5万佣金。',
  '代理B本周所有直属下级共有2名有效会员，且本周累计负盈利为100万，有效会员数处在返佣比例5%档，而负盈利100万处在返佣比例30%档，则只能适用5%，则下周一凌晨结算代理佣金时B可获得100万*5%=5万佣金。': '代理B本周所有直属下级共有2名有效会员，且本周累计负盈利为100万，有效会员数处在返佣比例5%档，而负盈利100万处在返佣比例30%档，则只能适用5%，则下周一凌晨结算代理佣金时B可获得100万*5%=5万佣金。',
  '代理B本周所有直属下级共有100名有效会员，且本周累计负盈利为3万，有效会员数处在返佣比例30%档，而负盈利3万处在返佣比例15%档，则适用15%，则下周一凌晨结算代理佣金时B可获得3万*15%=0.45万佣金。': '代理B本周所有直属下级共有100名有效会员，且本周累计负盈利为3万，有效会员数处在返佣比例30%档，而负盈利3万处在返佣比例15%档，则适用15%，则下周一凌晨结算代理佣金时B可获得3万*15%=0.45万佣金。',
  '根据以上代理B的例子可知，负盈利抽成方案对负盈利额和有效会员数的考核采取“就低”原则，即负盈利额和有效会员数哪个处在更低档返佣比例，就适用该更低档的返佣比例计算代理返佣。': '根据以上代理B的例子可知，负盈利抽成方案对负盈利额和有效会员数的考核采取“就低”原则，即负盈利额和有效会员数哪个处在更低档返佣比例，就适用该更低档的返佣比例计算代理返佣。',
  温馨提示: '温馨提示',
  '本模式意在鼓励代理直推，仅适用于直属下级代理，代理本身、直属代理继续往下发展的下下级代理和会员的存款、有效投注、负盈利，不计入该模式的核算。': '本模式意在鼓励代理直推，仅适用于直属下级代理，代理本身、直属代理继续往下发展的下下级代理和会员的存款、有效投注、负盈利，不计入该模式的核算。',
  '所有代理默认适用实时抽水方案，但是可根据需要将指定代理设置为按照周负盈利返佣。': '所有代理默认适用实时抽水方案，但是可根据需要将指定代理设置为按照周负盈利返佣。',
  '可根据需要，将部分游戏禁止算入有效投注的考核范围内。': '可根据需要，将部分游戏禁止算入有效投注的考核范围内。',
  '在周负盈利抽成方案中，直属下级在本周内充值、打码达到要求，才算一个有效会员。负盈利抽成方案对负盈利额和有效会员数的考核采取“就低”原则，即负盈利额和有效会员数哪个处在更低档返佣比例，就适用该更低档的返佣比例计算代理返佣，具体理解见下面例子。': '在周负盈利抽成方案中，直属下级在本周内充值、打码达到要求，才算一个有效会员。负盈利抽成方案对负盈利额和有效会员数的考核采取“就低”原则，即负盈利额和有效会员数哪个处在更低档返佣比例，就适用该更低档的返佣比例计算代理返佣，具体理解见下面例子。',
  '更改返佣模式：如某代理本周是方案一，在星期三修改为负盈利代理方案，则本周剩余时间都是方案一，下周一按照抽水代理方案结算本周，并且负盈利代理方案生效（下周二到下周天都不会进行抽水方案结算），下下周一按照负盈利方案结算下周的返佣。': '更改返佣模式：如某代理本周是方案一，在星期三修改为负盈利代理方案，则本周剩余时间都是方案一，下周一按照抽水代理方案结算本周，并且负盈利代理方案生效（下周二到下周天都不会进行抽水方案结算），下下周一按照负盈利方案结算下周的返佣。',
  本活动最终解释权归: '本活动最终解释权归',
  '所有。': '所有。',
  '您的佣金=1级返点+2级返点+3级返点': '您的佣金=1级返点+2级返点+3级返点',
  代理层级: '代理层级',
  一级: '一级',
  二级: '二级',
  三级: '三级',
  'A的佣金收入=B级会员的有效投注总额*70%+C级会员的有效投注总额*20%+D级会员的有效投注总额*10%': 'A的佣金收入=B级会员的有效投注总额*70%+C级会员的有效投注总额*20%+D级会员的有效投注总额*10%',
  'B的佣金收入=C级会员的有效投注总额*70%+D级会员的有效投注总额*20%+E级会员的有效投注总额*10%': 'B的佣金收入=C级会员的有效投注总额*70%+D级会员的有效投注总额*20%+E级会员的有效投注总额*10%',
  'C的佣金收入=D级会员的有效投注总额*70%+E级会员的有效投注总额*20%+F级会员的有效投注总额*10%': 'C的佣金收入=D级会员的有效投注总额*70%+E级会员的有效投注总额*20%+F级会员的有效投注总额*10%',
  '所有加入并成为我公司的代理合作伙伴，不仅享有分享受推荐红利，而且还可以从下线会员那里获得丰厚的代理佣金，下线会员越多，可获的佣金也越多': '所有加入并成为我公司的代理合作伙伴，不仅享有分享受推荐红利，而且还可以从下线会员那里获得丰厚的代理佣金，下线会员越多，可获的佣金也越多',
  '以此类推，一级级推广发展下去，每位代理可获得其下三级的投注佣金收益，且下线代理与上线代理互不影响自己的投注收益': '以此类推，一级级推广发展下去，每位代理可获得其下三级的投注佣金收益，且下线代理与上线代理互不影响自己的投注收益',
  代理个人有效投注不含佣金: '代理个人有效投注不含佣金',
  '返点是每日统计，次日派发': '返点是每日统计，次日派发',
  '全民参与{key}代理，轻松兼职赚百万': '全民参与{key}代理，轻松兼职赚百万',
  多种流水类型可供选择: '多种流水类型可供选择',
  N级返点无限领: 'N级返点无限领',
  推广返点流程: '推广返点流程',
  '无限级返点代理模式，双重现金任你拿': '无限级返点代理模式，双重现金任你拿',
  '自营、级差双重佣金': '自营、级差双重佣金',
  满足返点等级拿高额返现: '满足返点等级拿高额返现',
  代理转账已审批: '代理转账已审批',
  '假如您是A，你邀请了B、C、D，B又邀请了E和F，A无投注，B、C、D、E、F各投注10万。即A的总业绩为50万，属于返佣的第6级，每万80金币返佣。': '假如您是A，你邀请了B、C、D，B又邀请了E和F，A无投注，B、C、D、E、F各投注10万。即A的总业绩为50万，属于返佣的第6级，每万80金币返佣。',
  'B、C、D三人为A的直推下级，B、C、D总计投注30万，作为A的自营业绩，按每万80金币返佣。A的自营佣金=A自营业绩*A返佣比例=30*80=2400': 'B、C、D三人为A的直推下级，B、C、D总计投注30万，作为A的自营业绩，按每万80金币返佣。A的自营佣金=A自营业绩*A返佣比例=30*80=2400',
  级差佣金: '级差佣金',
  'B邀请了E和F，E和F共计投注20万，作为B的团队业绩20万，A可以从B的团队业绩获得级差佣金。A的级差佣金=（A返佣比例-B返佣比例）*B团队业绩=（80-60）*20=400': 'B邀请了E和F，E和F共计投注20万，作为B的团队业绩20万，A可以从B的团队业绩获得级差佣金。A的级差佣金=（A返佣比例-B返佣比例）*B团队业绩=（80-60）*20=400',
  '代理佣金包括直推佣金和级差佣金两部分。': '代理佣金包括直推佣金和级差佣金两部分。',
  '直推佣金：直属下级的自营流水*总业绩达到代理级别所对应的返佣比例。': '直推佣金：直属下级的自营流水*总业绩达到代理级别所对应的返佣比例。',
  '级差佣金：如您代理级别比您的直属下级高，那么您的返佣比例就高于您直属下级的返佣比例，此差额形成了每万流水业绩的级差，则级差佣金=级差（您的代理级别佣金比例-直属下级代理级别佣金比例）*直属下级的业绩。代理与直属下级之间存在级别差才能获取返点，没有级差无法获得返点。': '级差佣金：如您代理级别比您的直属下级高，那么您的返佣比例就高于您直属下级的返佣比例，此差额形成了每万流水业绩的级差，则级差佣金=级差（您的代理级别佣金比例-直属下级代理级别佣金比例）*直属下级的业绩。代理与直属下级之间存在级别差才能获取返点，没有级差无法获得返点。',
  '团队流水/团队有效投注额：指的是各游戏大类（如彩票类、棋牌类、真人视讯类等）的团队流水，每个大类需在后台单独设置有效投注额参数和返佣比例。': '团队流水/团队有效投注额：指的是各游戏大类（如彩票类、棋牌类、真人视讯类等）的团队流水，每个大类需在后台单独设置有效投注额参数和返佣比例。',
  '代理返佣结算时间：每天凌晨结算前一天。': '代理返佣结算时间：每天凌晨结算前一天。',
  立即邀请: '立即邀请',
  '彩票代理新模式，无限级返点差返佣': '彩票代理新模式，无限级返点差返佣',
  返点差满足所有条件: '返点差满足所有条件',
  返佣极速到账: '返佣极速到账',
  'A返点9.5%赔率为9.95，下级B返点9.1%赔率就是9.91，再下级C返点8.5%赔率就是9.85，则BC返点差0.6%，AB返点差0.4%；假设C有效投注10000金币，则B获得的代理佣金=0.6/100*10000=60，A获得的代理佣金=0.4/100*10000=40': 'A返点9.5%赔率为9.95，下级B返点9.1%赔率就是9.91，再下级C返点8.5%赔率就是9.85，则BC返点差0.6%，AB返点差0.4%；假设C有效投注10000金币，则B获得的代理佣金=0.6/100*10000=60，A获得的代理佣金=0.4/100*10000=40',
  '无限级返点差返佣代理，即代理根据其自身与(直属下级代理或直属下级会员)的返点差获取返佣，只要存在返点差，直属下级代理(以及次下级代理或会员、再次级代理或会员，以此类推)、直属会员进行彩票有效投注，代理都能根据返点差获得返佣。': '无限级返点差返佣代理，即代理根据其自身与(直属下级代理或直属下级会员)的返点差获取返佣，只要存在返点差，直属下级代理(以及次下级代理或会员、再次级代理或会员，以此类推)、直属会员进行彩票有效投注，代理都能根据返点差获得返佣。',
  '也可以在后台设置某个代理及以下即使存在返点差也不可获得返佣。': '也可以在后台设置某个代理及以下即使存在返点差也不可获得返佣。',
  '彩票代理返佣是实时自动到账的，注单结算完毕后到账。': '彩票代理返佣是实时自动到账的，注单结算完毕后到账。',
  '非彩票游戏：下级代理或会员投注非彩票类游戏（棋牌、真人、电子、捕鱼、体育、红包、电竞等），上级代理没有代理返佣。若': '非彩票游戏：下级代理或会员投注非彩票类游戏（棋牌、真人、电子、捕鱼、体育、红包、电竞等），上级代理没有代理返佣。若',
  '需要对该类游戏也设置返佣，可手工结算。': '需要对该类游戏也设置返佣，可手工结算。',
  '您的佣金=自营佣金+级差佣金': '您的佣金=自营佣金+级差佣金',
  冠亚和值指定值: '冠亚和值指定值',
  四位: '四位',
  五位: '五位',
  六位: '六位',
  七位: '七位',
  八位: '八位',
  九位: '九位',
  收藏: '收藏',
  '每{num}分钟一期': '每{num}分钟一期',
  '每天{num}期': '每天{num}期',
  后二和值: '后二和值',
}

export default {
  // kernel 里只放kernel公共项目里的翻译
  ...kernel,
  ...lotteryCN,
  ...thirdGamesCN,
  ...main,
  ...other,
  ...help,
};
